import React, { useState, useEffect, useRef } from 'react';
import { Button, Navbar, Form, InputGroup, Modal } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import MultiSelectDropdown from '../Controls/multiselectdropdown';
import { useDispatch, useSelector } from "react-redux";
import DateTimePicker from '../Controls/DateTimePicker';
import APICom from "../../utils/helpers/APICom";
import Cancelled from "../../assets/Images/CommonImages/cancel_icon.png";
import AtLocation from "../../assets/Images/CommonImages/at_location.png";
import Active from "../../assets/Images/CommonImages/pick.png";
import InActive from "../../assets/Images/CommonImages/drop.png";
import Dispatched from "../../assets/Images/CommonImages/dispatched.png";
import IRTPU from "../../assets/Images/CommonImages/irtpu.png";
import Completed from "../../assets/Images/CommonImages/trip_completed.png";
// import cancel_icon  from '../../assets/Images/CommonImages/cancel_icon.png';
// import activatetrip_icon from '../../assets/Images/CommonImages/undo_icon.png';
// import tripactions_icon from '../../assets/Images/CommonImages/redo_icon.png';
// import driveraction_icon from '../../assets/Images/CommonImages/driveraction_icon.png';
// import callback_icon from '../../assets/Images/CommonImages/callback.png'
// import vehicletracking_icon from '../../assets/Images/CommonImages/vehicletracker.png'
// import groupingaction_icon from '../../assets/Images/CommonImages/grouping_icon.png';
// import cluster_icon from '../../assets/Images/CommonImages/cluster.png';
// import history_icon from '../../assets/Images/CommonImages/history_icon.png';
import '../../assets/Styles/CancelTripCSS/CancelTripCSS.css';
import NumericControl from '../Controls/NumericControl';
import '../../assets/Styles/DispatchCSS/DispatchCSS.css';
import { Icon } from '@iconify/react';
import MenuSideBar from '../Dispatch/menuSideBar';
import { clearLoginData } from '../../features/login/loginSlice';
import EditRouteSettings from './EditRouteSettings';
import PersistStorage from '../../utils/helpers/PersistStorage';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { mainstore } from '../../store';
import DateTimeUtils from '../../utils/DateTimeUtility'
import MapVoice from '../Controls/MapControlDispatch/MapVoice/MapVoice';
import micIcon from '@iconify-icons/mdi/keyboard-voice';

const DispatchMainToolbar = (props = {}) => {

  //const GridSelectionState = {
  //  current: '',
  //  previous: '',
  //  date: new Date().toISOString().split('T')[0] // YYYY-MM-DD
  //};

  //function updateGridSelection(newSelection) {
  //  GridSelectionState.previous = GridSelectionState.current || '';
  //  GridSelectionState.current = newSelection;
  //  GridSelectionState.date = new Date().toISOString().split('T')[0];
  //}

  const [showCompltdTrips, setShowCompltdTrips] = useState(true);
  useEffect(() => {
    setShowCompltdTrips(props.showCompletedTrips);
  }, [props.showCompletedTrips]);



  const navigate = useNavigate();
  let _startDate = new Date();
  const { FamilyData, AffiliateData, FundingSourceData, AttributeData, GlobalASCSData } = useSelector((store) => store.combinedata);
  const { isLoggedIn, loginData } = useSelector((store) => store.login);
  const [CallAgentDefaultAffiliateID, setCallAgentDefaultAffiliateID] = useState(loginData.DefaultAffiliateID);
  const GetDefaultFamilyID = () => {
    try {
      for (var i = 0; i < AffiliateData.length; i++) {
        if (CallAgentDefaultAffiliateID.toString() === "-1") {
          return AffiliateData[0].DTSPID.toString();
        }
        else {
          if (AffiliateData[i]["AffiliateID"].toString() == CallAgentDefaultAffiliateID.toString()) {
            return AffiliateData[i].DTSPID.toString();
          }
        }
      }
      return "-1";
    }
    catch (o) { return "-1"; }
  };

  // try{
  //   if(PersistStorage.retrieve("DispatchToolBarDate", false) !== null){
  //     _startDate = new Date(PersistStorage.retrieve("DispatchToolBarDate", false));
  //   }
  // }
  // catch(e){_startDate = new Date(); }

  const _TodayDate = _startDate.getFullYear() + (_startDate.getMonth() < 9 ? "-0" : "-") + (_startDate.getMonth() + 1) + "-" + (_startDate.getDate() < 10 ? "0" : "") + _startDate.getDate();
  let reloadInterval; // Declare at the top for global access
  let iframe; // Declare at the top for global access
  let requestBody;
  const dropdownpadding = {
    paddingLeft: '50px',
    height: "40px !important",
    borderRadius: "0px !important"
  };

  const [HandleRouteSettingsEditPencil, setHandleRouteSettingsEditPencil] = useState([]);
  const [HandleRouteCheckDays, setHandleRouteCheckDays] = useState([]);
  const [UserAffiliateList, setUserAffiliateList] = useState(loginData.UserAffiliateList.split(','));
  const [menuSideBarToggle, setMenuSidebar] = useState(false);
  const [SelectedRouteOrCluster, setSelectedRouteOrCluster] = useState("");
  const [showRouteDropDown, setShowRouteDropDown] = useState(false);
  const [invokeEditRouteSettings, setInvokeEditRouteSettings] = useState(false);
  const [clusterFilterMultiSelect, setrouteFilterMultiSelect] = useState({ options: [], DropdownMode: 'rS', className:"RouteDropdownToolbarClass h-100", styles: {marginLeft: "0px"}, selectedValues: [] });
  const [StatusFilterMultiSelect, SetStatusFilterMultiSelect] = useState({options: [],selectedValues:[],placeholder:"Status Filter",displayValue:"name",emptyRecordMsg:"N/A",id:"DispatchGridStatusFilterSelect",className:"DispatchGridStatusFilterSelect toolbarGlobal text-nowrap",SelectAllPlaceHolder:"All Status", AllItemsSelectedPlaceHolder:"All Status",styles:{width:"auto", maxWidth:"150px", marginLeft:"0px"}});
  const [GroupingMultiSelect, SetGroupingMultiSelect] = useState({options: [], selectedValues:[], placeholder:"Grouping Filter", displayValue:"name", emptyRecordMsg:"N/A", 
    id:"DispatchGridGroupSelect", className:"DispatchGridGroupSelect toolbarGlobal text-nowrap", 
    singleSelect:false, SingleSelectClass:"h-100", showCheckbox:false, SelectAllPlaceHolder:"All Group", 
    AllItemsSelectedPlaceHolder:"All Group", styles:{width:"auto", marginLeft:"3px"}
  });
  const [FamilyGroupsSingleSelect, SetFamilyGroupsMultiSelect] = useState({options: [], selectedValues:[GetDefaultFamilyID()], placeholder:"Family Filter",
    displayValue:"name", emptyRecordMsg:"N/A", id:"DispatchGridFamilySelect",
    className:"DispatchGridFamilySelect", singleSelect:true, SingleSelectClass:"h-100", 
    showCheckbox:false, TriggerSelectEventOnDataPopulate: false, styles:{width:"auto", marginLeft:"3px", borderRadius:"0px"}
  });
  const [AttributesFilterMultiSelect, SetAttributesFilterMultiSelect] = useState({options: [], selectedValues:[], placeholder:"Attributes Filter", 
    displayValue:"name", emptyRecordMsg:"N/A", id:"DispatchGridAttributesSelect", className:"DispatchGridAttributesSelect toolbarGlobal text-nowrap", 
    SelectAllPlaceHolder:"All Attributes", AllItemsSelectedPlaceHolder:"All Attributes", styles:{width:"auto", marginLeft:"3px"}
  });
  const [AffiliatesFilterMultiSelect, SetAffiliatesFilterMultiSelect] = useState({options: [], selectedValues:[CallAgentDefaultAffiliateID], 
    placeholder:"Select Affiliates", displayValue:"name", emptyRecordMsg:"N/A", id:"DispatchGridAffiliatesSelect", 
    className:"DispatchGridAffiliatesSelect text-nowrap", singleSelect:true, SingleSelectClass:"h-100", showCheckbox:false, 
    TriggerSelectEventOnDataPopulate: false, styles:{width:"auto", marginLeft:"3px"}
  });
  const [FundingSourceFilterMultiSelect, SetFundingSourceFilterMultiSelect] = useState({options: [], selectedValues:[], placeholder:"Select FS", displayValue:"name", 
    emptyRecordMsg:"N/A", id:"DispatchGridFundingSourcesSelect", className:"DispatchGridFundingSourcesSelect toolbarGlobal text-nowrap", 
    SelectAllPlaceHolder:"All FS", AllItemsSelectedPlaceHolder:"All FS", styles:{width:"auto", maxWidth:"150px", marginLeft:"3px"}
  });
  const [RequestDateOptions, SetRequestDateOptions] = useState({placeholder:"", disable:false, id:"DisptachGridRequestDate", 
    className:"DisptachGridRequestDate", hidePlaceholder:false, styles:{width:"130px", minWidth:"130px", marginLeft:"3px", height:"100%"}, 
    SelectAllPlaceHolder:"Select All", initialDate:_startDate
  });
  const [RequestDateOptionsRange, SetRequestDateOptionsRange] = useState({placeholder:"", disable:false, className:"DisptachGridRequestDate", 
    hidePlaceholder:false, styles:{width:"130px", minWidth:"130px", marginLeft:"3px", height:"100%"}, 
    SelectAllPlaceHolder:"MM/DD/YYYY", initialDate:""
  });
  const [RequestTotalHoursOptions, SetRequestTotalHoursOptions] = useState({
    placeholder: "",
    disable: false,
    id: "RequestTotalHoursOptions",
    className: "RequestTotalHoursOptions",
    hidePlaceholder: false,
      styles: { width: "70px", marginLeft: "3px", borderRadius: "0px" },
    initialValue: "24",
    maxValue: "24",
    minValue: "0"
  });
  const [selectedDate, setselectedDate] = useState(moment().format('YYYY-MM-DD'));
  const [selectedDateRange, setSelectedDateRange] = useState('');
  const [numericValue, setNumericValue] = useState(24);
  const [sendEmailDict, setSendEmailDict] = useState({showCustomerEmailRequest: false , customerTripData: {}});
  const [customerEmail, setCustomerEmail] = useState("");
  const [emailAlert, setShowEmailAlert] = useState("");

  const IsCalledFromPageReload = useRef(false)
  const PageReload = useRef(false)
  const savedStatuses = useRef([{ "name": "Undispatched", "id": "Undispatched" }, { "name": "In Progress", "id": "In Progress" },
    { "name": "Cancelled", "id": "Cancelled" }, { "name": "No-Show", "id": "No-Show" }, { "name": "Will Call", "id": "Will Call" },
    { "name": "Flagger", "id": "Flagger" }, { "name": "Hide Break/Depot Trips", "id": "Hide Break/Depot Trips" }
  ]);
  const savedGrouping = useRef([{ "name": "Grouped", "id": "1" }, { "name": "UnGrouped", "id": "2" }]);

  function IsPageReloadCalled(_isCalledFromPageReload) {
    try {
      IsCalledFromPageReload.current = _isCalledFromPageReload;
    } catch (error) {

    }
  }
  const [updateCheckDays, setUpdateCheckDays] = useState([]);
  const [newDateOnEditRoute, setNewDateOnEditRoute] = useState();
  // const [isCheckedForRouteDropDown, setIsCheckedForRouteDropDown] = useState(false);
  const [showDynamicModal, setShowDynamicModal] = useState(false);
  const [modalBodyHTML, setModalBodyHTML] = useState(null);
  const [modalFooterHTML, setModalFooterHTML] = useState(null);
  const [modalHeaderText, setModalHeaderText] = useState("");
  const [ToolboxValues, SetToolboxValues] = useState({
    Date: _TodayDate, AffiliatesList: "", FSList: "", AttrList: "", StatusList: "", Grouping: "", TotalHours: 24
  });
  const [mainGridType, setMainGridType] = useState("Dispatch");
  const [selectedBtns, setSelectedBtns] = useState([]);
  const [givenDynamicModalSize, setGivenDynamicModalSize] = useState(0);
  const [isMapToggling, setIsMapToggling] = useState(false);
  const [actionBtnTopPos, setActionBtnTopPos] = useState(()=>{
    const height = window.innerHeight;
    if(height >= 715){
      return '6%';
    }
    else if(height >= 550 && height < 715){
      return '9%';
    }
    else if(height < 550 && height >= 400){
      return '11%';
    }
    else if(height < 400){
      return '14%';
    }
  });

  const dispatch = useDispatch();

  const buttonConfigsRef = useRef({
    Input: { btnName: "input", btnFunc: handleUserInput, icon: "NA", title: "" },
    SignOut: { btnName: "Sign Out", btnFunc: handleLogout, icon: "bx:log-out", title: "Sign Out" },
    RouteActivityPlot: { btnName: "Daily OTP Plot", btnFunc: openHtmlRouteActivity, icon: "gis:map-route", title: "Daily OTP Plot" },
    ManifestSettings: { btnName: "Manifest Settings", btnFunc: navigateToPage, icon: "rivet-icons:gears", title: "Manifest Settings" },
    StandingRoutes: { btnName: "Standing Routes", btnFunc: handleStandingRouteActions, icon: "bx:table", title: "Manage/Save Standing Routes" },
    RBSProcess: { btnName: "RBSProcess", btnFunc: handleInvokeRBSProcessActions, icon: "bx:dice-1", title: "RBSProcess" },
    CancelTrip: { btnName: "Cancel", btnFunc: handleInvokeCancelTrip, icon: "ic:baseline-cancel", title: "Cancel Trip", tag: "tag_CancelRequest" },
    ActivateTrip: { btnName: "Activate", btnFunc: handleInvokeActivateTrip, icon: "mdi:tick-circle", title: "Activate Trip" },
    TripReservation: { btnName: "Trip Reservation", btnFunc: handleInvokeCallAgent, icon: "bx:book-bookmark", title: "Reserve a trip" },
    TripEdit: {btnName: "Trip Edit", btnFunc: handleInvokeEditTripCallAgent, icon:"bx:edit", title: "Edit a trip"},
    TripCopy: {btnName: "Copy Ride", btnFunc: handleInvokeCopyTripCallAgent, icon:"grommet-icons:copy", title: "Copy a trip"},
    AgileDispatch: { btnName: "Agile Dispatch", btnFunc: handleInvokeAgileDispatch, icon: "bx:vector", title: "Agile Dispatch", tag: "tag_DispatchActions" },
    DispatchActions: { btnName: "Dispatch Actions", btnFunc: handleInvokeTripActions, icon: "bx:cog", title: "Dispatch Actions" },
    DriverControls: { btnName: "Driver Controls", btnFunc: handleInvokeDriverActions, icon: "bx:taxi", title: "Driver & Admin Actions" },
    VehicleTracking: { btnName: "Vehicle Tracking", btnFunc: handleInvokeVehicleTracking, icon: "bx:message-detail", title: "Send Vehicle Tracking Message" },
    CallbackCounter: { btnName: "Callback Counter", btnFunc: handleInvokeUpdateCallback, icon: "bx:phone-call", title: "Update Customer Callback Counter" },
    GroupingActions: { btnName: "Grouping Actions", btnFunc: handleInvokeGroupingActions, icon: "bx:dice-5", title: "Group/UnGroup Actions" },
    ClusteringActions: { btnName: "Clustering Actions", btnFunc: handleInvokeClusteringActions, icon: "bx:network-chart", title: "Cluster/Uncluster Trips" },
    TripHistory: { btnName: "Trip History", btnFunc: handleInvokeTripHistoryActions, icon: "bx:history", title: "Trip History" },
    BrokerActions: {btnName: "Broker Actions", btnFunc: handleBrokerActions, icon:"bx:group", title: "Broker Actions"}, 
    ManifestActions: {btnName: "Manifest Actions", btnFunc: handleInvokeBuildManifestActions, icon:"bx:trip", title: "Manifest Action"},
    RouteRestrictions: {btnName: "Route Restrictions", btnFunc: handleInvokeShowRoutes, icon:"bx:shield", title: "Route Restrictions"},
    TripInfo: {btnName: "Trip Information", btnFunc: handleTripInformation, icon:"bx:info-circle", title: "Trip Information"},
    ZoneSpeedMultiplier: {btnName: "Zone Speed Multiplier", btnFunc: handleSpeedZoneMultiplier, icon:'bx:map-alt', title: "Zone Speed Multiplier"},
    reportActions: {btnName: "Trips Dashboard", btnFunc: openHtmlTripsDashboard, icon:'bx:map-alt', title: "Trips Dashboard"},
    fixReportActions: {btnName: "Fixbus Dashboard", btnFunc: openHtmlFixedBusDashboard, icon:'bx:map-alt', title: "Fixbus Dashboard"},
    paratransit: {btnName: "Paratransit Dashboard", btnFunc: openParatransitDashboard, icon:'bx:map-alt', title: "Paratransit Dashboard"},
    AIReport: {btnName: "AI Reporting", btnFunc: openAIChat, icon:'bx:map-alt', title: "ITcurves AI reporting"},
    MTDiagnostic: {btnName: "MT Diagnostic", btnFunc: handleMTDiagnostic, icon:"bx:info-circle", title: "MT Diagnostic"},
    AgentInstructions: {btnName: "Agent Notes", btnFunc: handleAgentNotesAction, icon:"lucide:notebook-pen", title: "Agent Notes"},
    AddUpdateExtraInfo: {btnName: "Add Extra Info", btnFunc: handleAddUpdateExtraInfo, icon:"proicons:note-add", title: "Add/Update Extra Info"},
    ShowMultiSch: {btnName: "Show Multi-Sch", btnFunc: handleShowMultiSchAction, icon: "grommet-icons:schedules", title: "Show Multi-Schedule Trips"},
    SendEmail: {btnName: "Send Email", btnFunc: handleSendEmail, icon: "fontisto:email", title: "Send Receipt Email"}
  });
  const globalBtnsRef = useRef(["Input", "SignOut"]);
  const microtransitBtnsRef = useRef([
    "TripReservation",
    "CancelTrip", "ActivateTrip", "AgileDispatch", "DispatchActions", "TripHistory", "TripInfo",
    "DriverControls", "VehicleTracking", "CallbackCounter",
    "BrokerActions",
    "RouteActivityPlot", "ManifestSettings", "StandingRoutes", "RBSProcess", "GroupingActions", "ClusteringActions", "ManifestActions", "RouteRestrictions",
    "MTDiagnostic"
  ]);
  const paratransitBtnsRef = useRef([
    "TripReservation", "TripEdit",
    "CancelTrip", "ActivateTrip", "AgileDispatch", "DispatchActions", "TripHistory", "TripInfo",
    "DriverControls", "VehicleTracking", "CallbackCounter",
    "BrokerActions",
    "RouteActivityPlot", "ManifestSettings", "StandingRoutes", "RBSProcess", "GroupingActions", "ClusteringActions", "ManifestActions", "RouteRestrictions",
    "ZoneSpeedMultiplier", "reportActions", "fixReportActions",  "paratransit", "AIReport"
  ]);
  const standingOrderBtnRef = useRef([
    "TripReservation", "TripEdit",
    "CancelTrip", "TripHistory",
    "SendEmail",
    "AgentInstructions",
    "ShowMultiSch"
  ]);
  const completedQueueBtnRef = useRef([
    
    "TripHistory",
    "DriverControls",
    "AgentInstructions",
    "RouteActivityPlot",
    "reportActions",
    "fixReportActions",
    "paratransit",
    "AIReport",
  ]);
  // "TripCopy", "AddUpdateExtraInfo"
  const clusterComboData = useRef([]);
  const clusterComboDataBackup = useRef([]);
  const mainGridRowData = useRef([]);
  const menuTracker = useRef(false);
  const navBarRef = useRef(null);
  const affiliateRef = useRef(0);
  const transitTypeRef = useRef([]);
  const APICallRef = useRef(false);
  const editRouteSetDataRef = useRef([]);
  const affChangeFlagRef = useRef("");
  const affSelectedRef = useRef("");
  const ArbCheckedOnGuiRef = useRef(true);
  const mapBtnRef = useRef(null);
  const showCompletedCheckRef = useRef(false);
  const calltakerRef = useRef(null);
  const tableOptionsRef = useRef(null);
  const xCancelSourceForGrid = useRef(null);
  const IsGetAllTodayRoutesCallInProgress = useRef(false);
  const resizeTimeoutRef = useRef(null);
  const formRef = useRef(null);
  // const isProcessing = useRef(false);

  useEffect(() => {
    function handleResize () {
      try{
        if(resizeTimeoutRef.current){
          clearTimeout(resizeTimeoutRef.current);
        }
        resizeTimeoutRef.current = setTimeout(() => {
          const height = window.innerHeight;
          let heightAdjust = '6%';
          if(formRef.current) {
            const hasOverflow = formRef.current.scrollHeight > 44;
            // if(navBarRef.current.offsetWidth >= 1500){setShowFilters(false);}
          }
          if(height >= 715){
            heightAdjust = '6%';
          }
          else if(height >= 550 && height < 715){
            heightAdjust = '9%';
          }
          else if(height < 550 && height >= 400){
            heightAdjust = '11%';
          }
          else if(height < 400){
            heightAdjust = '14%';
          }
          setActionBtnTopPos(heightAdjust);

        }, 500);
      }
      catch(err){console.log(err);}
    }

    try {
      PageReload.current = true;
      let _savedStatuses = PersistStorage.retrieve("_SelectedStatuses", false);
      if (_savedStatuses != undefined && _savedStatuses != null) {
        savedStatuses.current = PersistStorage.retrieve("_SelectedStatuses", false);
      }
      let _savedGrouping = PersistStorage.retrieve("_SelectedGrouping", false);
      if (_savedGrouping != undefined && _savedGrouping != null) {
        savedGrouping.current = PersistStorage.retrieve("_SelectedGrouping", false);
      }
      IsCalledFromPageReload.current = true;
      let initialFamilyGroupSelected = [];
      // SetStatusFilterMultiSelect({ ...StatusFilterMultiSelect, ...{options: [{"name":"Undispatched", "id":"Undispatched"}, {"name":"In Progress", "id":"In Progress"}, {"name":"Cancelled", "id":"Cancelled"}, {"name":"No-Show", "id":"No-Show"}, {"name":"Will Call", "id":"Will Call"}, {"name":"Flagger", "id":"Flagger"}, {"name":"Hide Break/Depot Trips", "id":"Hide Break/Depot Trips"}]}});
      // SetGroupingMultiSelect({ ...GroupingMultiSelect, ...{options: [{"name":"Grouped", "id":"1"}, {"name":"UnGrouped", "id":"2"}]}});
      // SetAttributesFilterMultiSelect({ ...AttributesFilterMultiSelect, ...{options: []}});
      UpdateStatusesFromPersistStorage();
      UpdateGroupingFromPersistStorage();
      let allowedaffiliates = loginData.UserAffiliateList.split(',');
      let allowedFamilies = []
      if (allowedaffiliates.length > 0) {
        try {
          for (var i = 0; i < AffiliateData.length; i++) {
            if (allowedaffiliates.indexOf(AffiliateData[i]["AffiliateID"].toString()) > -1) {
              allowedFamilies.push(AffiliateData[i].DTSPID.toString());
            }
          }
        }
        catch (o) { }
      }
      let savedFamily = PersistStorage.retrieve("_SelectedFamily", false);
      let optsFamily = [];
      let FirstFamilyID = true;
      for (var i = 0; i < FamilyData.length; i++) {
        if (allowedFamilies.length > 0 && allowedFamilies.indexOf(FamilyData[i]["iATSPGroupID"].toString()) < 0) {
          continue;
        }
        if (FirstFamilyID == true) { FirstFamilyID = false; initialFamilyGroupSelected.push(FamilyData[i]["iATSPGroupID"].toString()); }
        optsFamily.push({ "name": FamilyData[i]["vATSPGroupName"], "id": FamilyData[i]["iATSPGroupID"] })
      }
      // SetFamilyGroupsMultiSelect({ ...FamilyGroupsSingleSelect, ...{options: optsFamily}});
      // FilterAffiliatesBySelectedFamily(initialFamilyGroupSelected);
      if (savedFamily != undefined && savedFamily != null && savedFamily != "") {
        SetFamilyGroupsMultiSelect({ ...FamilyGroupsSingleSelect, ...{ options: optsFamily, selectedValues: savedFamily } });
      }
      else {
        SetFamilyGroupsMultiSelect({ ...FamilyGroupsSingleSelect, ...{ options: optsFamily } });
      }

      if (savedFamily != undefined && savedFamily != null && savedFamily != "") {
        FilterAffiliatesBySelectedFamily(savedFamily, IsCalledFromPageReload.current, true);
      }
      else {
        FilterAffiliatesBySelectedFamily(initialFamilyGroupSelected);
      }

      let familyID = GetDefaultFamilyID();

      if (savedFamily != undefined && savedFamily != "" && savedFamily != null) {
        familyID = savedFamily;
      }

      SetSavedDate(true);

      clusterComboData.current = [];
      affChangeFlagRef.current = "";
      affChangeFlagRef.current = props.selectedAffiliates;
      showDropDownOptions({ Given: "COMPANY", Value: familyID });

      UpdateAttributesFromPersistStorage();

      let savedHours = PersistStorage.retrieve("_SelectedTotalHours", false);
      if (savedHours != null && savedHours != undefined && savedHours != "") {
        SetSavedTotalHours(savedHours);
      }
      window.addEventListener('resize', handleResize);
      return() =>{ window.removeEventListener('resize', handleResize); clearTimeout(resizeTimeoutRef.current);}
    }
    catch (err) { console.log(err); return() => {window.removeEventListener('resize', handleResize); clearTimeout(resizeTimeoutRef.current);}}
  }, []);

  useEffect(() => {
    try {
      setNumericValue(parseInt(RequestTotalHoursOptions.initialValue));
      SetToolboxValues({ ...ToolboxValues, ...{ TotalHours: parseInt(RequestTotalHoursOptions.initialValue) } });
    }
    catch (err) { console.log(err); }
  }, [RequestTotalHoursOptions]);

  useEffect(() => {
    try {
      HandleRouteSettingsEditPencil.forEach(ref => {
        ref.addEventListener('click', handleRouteSettingEdit);
      });
      return () => {
        HandleRouteSettingsEditPencil.forEach(ref => {
          ref.removeEventListener('click', handleRouteSettingEdit);
        });
      };
    }
    catch (err) { console.log(err); }

  }, [HandleRouteSettingsEditPencil]);

  useEffect(() => {
    try {
      HandleRouteCheckDays.forEach(ref => {
        ref.addEventListener('click', handleDayCheckRef);
      });
      return () => {
        HandleRouteCheckDays.forEach(ref => {
          ref.removeEventListener('click', handleDayCheckRef);
        });
      };
    }
    catch (err) { console.log(err); }
  }, [HandleRouteCheckDays]);

  useEffect(() => {
    // if(props.mainSelectedRow)
      mainGridRowData.current = props.mainSelectedRow;

  }, [props.mainSelectedRow]);

  useEffect(() => {
    try {
      if (typeof props.ToolBoxStateChange === "function") {
        props.ToolBoxStateChange(ToolboxValues);
      }
    }
    catch (err) { console.log(err); }
  }, [ToolboxValues]);

  useEffect(()=>{
    try{
      
      if(props.setDateRange)
      {
        let SavedData = PersistStorage.retrieve("DispatchToolBarDate", false);
     
        if (SavedData) {
          if (SavedData.includes("Z")) {
            _startDate = new Date(SavedData.replace("Z", "") + " 00:00:00");
          } else if (/^\d{4}-\d{2}-\d{2}$/.test(SavedData)) {
            _startDate = SavedData; // use as-is
          } else {
            let [year, month, day] = SavedData.split("-");
            _startDate = new Date(year, parseInt(month) - 1, day, 0, 0, 0);
          }
        }
        

        // if (SavedData !== null && SavedData !== undefined && SavedData !== "") {
        //   if (SavedData.includes("Z")) {
        //     _startDate = new Date(SavedData.replace("Z", "") + " 00:00:00");
        //   }
        //   else {
        //     let year = SavedData.split("-")[0];
        //     let month = SavedData.split("-")[1];
        //     let day = SavedData.split("-")[2];
        //     _startDate = year + "-" + month + "-" + day;
        //     _startDate = new Date(year, (parseInt(month) - 1), day, 0, 0, 0);
        //   }
        // }

        if(_startDate != undefined && completedDateChangeDirectCall.current == false){
          props.setDateRange({from: _startDate, to: _startDate});  
        }
        else{
          props.setDateRange({from: selectedDateRange, to: selectedDateRange});
          completedDateChangeDirectCall.current = true;
        }

      }
    } catch(err){console.log(err);}
  }, [selectedDateRange]);

  useEffect(()=>{
    try{
      tableOptionsRef.current = props.options;
      let SavedData = PersistStorage.retrieve("DispatchToolBarDate", false);
      if(props.options.GridName.toLowerCase() === 'completedqueue' && (SavedData == null || SavedData == undefined || SavedData == "")){
        getServerTime();
      }
      else{
        if (SavedData) {
          if (SavedData.includes("Z")) {
            _startDate = new Date(SavedData.replace("Z", "") + " 00:00:00");
          } else if (/^\d{4}-\d{2}-\d{2}$/.test(SavedData)) {
            _startDate = SavedData; // use as-is
          } else {
            let [year, month, day] = SavedData.split("-");
            _startDate = new Date(year, parseInt(month) - 1, day, 0, 0, 0);
          }
        }

        if(_startDate != undefined){
          props.setDateRange({from: _startDate, to: _startDate});  
        }
        else{
          props.setDateRange({from: selectedDateRange, to: selectedDateRange});
        }
      }
    }catch(err){console.log(err); tableOptionsRef.current = props.options;}
  }, [props.options]);

  useEffect(() => {
    try {
      affSelectedRef.current = (props.selectedAffiliates.includes(",") ? props.selectedAffiliates.split(",")[0] : props.selectedAffiliates);
      let sections = props.selectedAffiliates.split(',');
      let firstAff = "";
      if (sections.length > 0) {
        firstAff = parseInt(sections[0]);
      }
      else {
        firstAff = (props.selectedAffiliates && props.selectedAffiliates !== "" ? parseInt(props.selectedAffiliates) : 0);
      }
      if (firstAff > 0) {
        transitTypeRef.current = AffiliateData.filter((item, index) => {
          try {
            return parseInt(item.AffiliateID) === firstAff;
          }
          catch (err) { console.log(err); }
        });
        let requiredBtns = (transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2 ?
          (microtransitBtnsRef.current.concat(globalBtnsRef.current)) : (tableOptionsRef.current && tableOptionsRef.current.GridName.toLowerCase() === 'standingorder' ? 
            standingOrderBtnRef.current.concat(globalBtnsRef.current) : (tableOptionsRef.current && tableOptionsRef.current.GridName.toLowerCase() === 'completedqueue' ?
            completedQueueBtnRef.current.concat(globalBtnsRef.current) : paratransitBtnsRef.current.concat(globalBtnsRef.current)))
        );
        setSelectedBtns(requiredBtns);
      }
    }
    catch (err) { console.log(err); }
  }, [props.selectedAffiliates]);

  useEffect(() => {
    try {
      if (typeof props.ToolBoxStateChange === "function") {
        let affiliateList = String(ToolboxValues.AffiliatesList);
        let checkFlag = (affiliateList.includes(",") ?
          !affiliateList.includes(affSelectedRef.current) : affiliateList !== affSelectedRef.current);
        if (affSelectedRef.current !== "" && checkFlag) {
          let affSelection = (String(ToolboxValues.AffiliatesList).includes(",") ? String(ToolboxValues.AffiliatesList).split(",")[0] : ToolboxValues.AffiliatesList);
          affSelectedRef.current = affSelection;
          clusterComboData.current = [];
          // console.log("toolbox", affSelection, ToolboxValues.AffiliatesList, props.selectedAffiliates);
          showDropDownOptions({ Given: "AFFILIATE", Value: affSelection });
        }
      else if (affSelectedRef.current !== "" && ToolboxValues.Date) {
        showDropDownOptions({ Given: "AFFILIATE", Value: affSelectedRef.current });
      }
      }
    }
    catch (err) { console.log(err); }

  }, [ToolboxValues.AffiliatesList, ToolboxValues.Date, ToolboxValues.StatusList]);


  useEffect(() => {
    try {
      if (savedStatuses.current && savedStatuses.current.length > 0) {
        SetToolboxValues(prevToolboxValues => ({
          ...prevToolboxValues,
          StatusList: savedStatuses.current.map(status => status.name).join(",")
        }));
      }
    }
    catch (err) { console.log(err); }
  }, [savedStatuses.current]);


  useEffect(() => {
    try {
      if (savedGrouping.current && savedGrouping.current.length > 0) {
        SetToolboxValues(prevToolboxValues => ({
          ...prevToolboxValues,
          Grouping: savedGrouping.current.map(grpng => grpng.name).join(",")
        }));
      }
    }
    catch (err) { console.log(err); }
  }, [savedGrouping.current]);

  useEffect(() => {
    try {
      if (props.nullifyActivated) {
        props.setNullifyActivated(false);
        let affSelection = (ToolboxValues.AffiliatesList.includes(",") ? ToolboxValues.AffiliatesList.split(",")[0] : ToolboxValues.AffiliatesList);
        showDropDownOptions({ Given: "AFFILIATE", Value: affSelection });
      }
    }
    catch (err) { console.log(err); }
  }, [props.nullifyActivated]);

  useEffect(() => {
    try {
      setSelectedRouteOrCluster(props.selectedRoute);
      setrouteFilterMultiSelect({ ...clusterFilterMultiSelect, ...{ selectedValues: GetClusterSelectObjectBy(props.selectedRoute) }});
    }
    catch (err) { console.log(err); }
  }, [props.selectedRoute]);

  useEffect(() => {
    try {
      if (props.initiateCallTaker === 'Reserve') {
        handleInvokeCallAgent();
        props.setCallTakerDisp('None');
      }
      else if (props.initiateCallTaker === 'Edit') {
        handleInvokeEditTripCallAgent();
        props.setCallTakerDisp('None');
      }
      else if(props.initiateCallTaker === 'Copy')
      {
        setModalHeaderText("Upcoming Feature");
        setModalBodyHTML(<p><b>{"Copy Ride"}</b>{" is a work in progress and will be available in an upcoming release."}</p>);
        setModalFooterHTML(
            <Button variant="dark" className="mx-1 border-0" onClick={()=>setShowDynamicModal(false)}>
            {"OK"}
            </Button>
        );
        setShowDynamicModal(true);
        props.setCallTakerDisp('None');
      }
    }
    catch (err) { console.log(err); }
  }, [props.initiateCallTaker])

  async function getServerTime () {
    try{
      
      let serverDateTime = await DateTimeUtils.getCurrentSystemDateTime();

      const regex = /^(\d{1,2}\/\d{1,2}\/\d{4})/;
      // Match the time and AM/PM
      const match = serverDateTime.match(regex);
      if(match)
      {
        const formattedDate = `${match[1].split("/")[2]}-${match[1].split("/")[0].padStart(2, '0')}-${match[1].split("/")[1].padStart(2, '0')}`;
        SetRequestDateOptionsRange(prevState=>({...prevState, initialDate: match[1], maxLimit: formattedDate}));
        setSelectedDateRange(formattedDate);
      }
      else
      {
        let systemDate = new Date();
        SetRequestDateOptionsRange(prevState=>({...prevState, initialDate: systemDate, maxLimit: systemDate}));
        setSelectedDateRange(moment().format('YYYY-MM-DD'));
      }
    }
    catch(err){console.log(err);}
  }

  function handleLogout () {
    // Perform logout actions here
    // For example: clear authentication tokens, redirect, etc.
    try {
      if (isLoggedIn) {
        PersistStorage.save("agentTrips", [], 9999, true);
        if (calltakerRef.current && !calltakerRef.current.closed) { calltakerRef.current.close(); }
        dispatch(clearLoginData());
        // localStorage.setItem(
        //   "forceLogout",
        //   JSON.stringify({
        //     user: "",
        //     redirectTo: '/Login',
        //     ts: Date.now()
        //   })
        // );
      }
    }
    catch (err) { console.log(err); dispatch(clearLoginData()); }
  }

  const handleCheckSelectedTrip = async (rowSelectedCheck, CheckMultiScheduleValidation = true) => {
    try {
      let serviceID = (tableOptionsRef.current && tableOptionsRef.current.GridName.toLowerCase() === 'standingorder' ? rowSelectedCheck[0].iScheduleID : rowSelectedCheck[0].ServiceID);

      if (rowSelectedCheck[0].CreatedBy && rowSelectedCheck[0].CreatedBy === '(ExternalDispatch)') {
        setModalHeaderText("Edit Restricted");
        setModalBodyHTML(<b>{"This is a broker trip, editing is not allowed!"}</b>);
        setModalFooterHTML(
          <Button variant='secondary' className="border-0" onClick={() => setShowDynamicModal(false)}>
            OK
          </Button>
        );
        setShowDynamicModal(true);
      }
      else if (rowSelectedCheck[0].PickupPerson.toLowerCase() === "breaktrip") {
        setModalHeaderText("Break Trip Selected");
        setModalBodyHTML(<b>{"Action not Allowed for Break Trip!"}</b>);
        setModalFooterHTML(
          <Button variant='secondary' className="border-0" onClick={() => setShowDynamicModal(false)}>
            OK
          </Button>
        );
        setShowDynamicModal(true);
      }
      else if (rowSelectedCheck[0].PickupPerson.toLowerCase() === "sdepot" || rowSelectedCheck[0].PickupPerson.toLowerCase() === "edepot") {
        setModalHeaderText("Depot Trip Selected");
        setModalBodyHTML(<b>{"Action not Allowed for Depot Trips!"}</b>);
        setModalFooterHTML(
          <Button variant='secondary' className="border-0" onClick={() => setShowDynamicModal(false)}>
            OK
          </Button>
        );
        setShowDynamicModal(true);
      }
      else if (rowSelectedCheck[0].BelongstoSegment && rowSelectedCheck[0].BelongstoSegment.toLowerCase() === "true") {
        setModalHeaderText("Segmented Trip");
        setModalBodyHTML(<b>{"Trip is part of a segment. Edit is not allowed for segmented trip."}</b>);
        setModalFooterHTML(
          <Button variant='secondary' className="border-0" onClick={() => setShowDynamicModal(false)}>
            OK
          </Button>
        );
        setShowDynamicModal(true);
      }
      else if (!serviceID || String(serviceID) === "-1") {
        setModalHeaderText("Record Not Found");
        setModalBodyHTML(<b>{"Trip does not have a service ID and can't be edited."}</b>);
        setModalFooterHTML(
          <Button variant='secondary' className="border-0" onClick={() => setShowDynamicModal(false)}>
            OK
          </Button>
        );
        setShowDynamicModal(true);
      }
      else if (rowSelectedCheck[0].TripRequestStatus && (rowSelectedCheck[0].TripRequestStatus.toLowerCase() === "cancel" || rowSelectedCheck[0].TripRequestStatus.toLowerCase() === "noshow" || rowSelectedCheck[0].TripRequestStatus.toLowerCase() === "noshowed")) {
        setModalHeaderText("Edit Restricted");
        setModalBodyHTML(<b>{"Action not allowed on trip with status " + String(rowSelectedCheck[0].TripRequestStatus)}</b>);
        setModalFooterHTML(
          <Button variant='secondary' className="border-0" onClick={() => setShowDynamicModal(false)}>
            OK
          </Button>
        );
        setShowDynamicModal(true);
      }
      else {
        if (tableOptionsRef.current.GridName.toLowerCase() === 'standingorder' && CheckMultiScheduleValidation) {
          setGivenDynamicModalSize('xl');
          setModalHeaderText("Multi-Schedule Edit");
          setModalBodyHTML(<p className='user-select-none m-0'>{"Multi-schedule trip for pickup person '"}<b>{String(rowSelectedCheck[0].PickupPerson)}</b>{"' may have expanded routed/dispatched trips, which may get unrouted on edit. Do you want to proceed?"}</p>);
          setModalFooterHTML(
            <>
              <Button variant='dark' className="border-0" onClick={() => { setShowDynamicModal(false); handleCheckSelectedTrip(rowSelectedCheck, false); setGivenDynamicModalSize(0); }}>
                Yes
              </Button>
              <Button variant='secondary' className="border-0" onClick={() => { setShowDynamicModal(false); setGivenDynamicModalSize(0); }}>
                No
              </Button>
            </>
          );
          setShowDynamicModal(true);
        }
        else {
          let confirmation = (rowSelectedCheck[0].ConfirmationNo ? rowSelectedCheck[0].ConfirmationNo : rowSelectedCheck[0]["Confirmation #"]);
          let scheduled = (tableOptionsRef.current && tableOptionsRef.current.GridName.toLowerCase() === 'standingorder') ? true: String(rowSelectedCheck[0].bIsSchedule).toLowerCase() === "true";
          let requestTypeVal = (tableOptionsRef.current && tableOptionsRef.current.GridName.toLowerCase() === 'standingorder' ? "Time Call" : (tableOptionsRef.current.GridName.toLowerCase() === 'completedqueue' ? (rowSelectedCheck[0].RequestType.toLowerCase().includes("time") ? "Time Call":"On Demand") : rowSelectedCheck[0].TableSource.toLowerCase().includes("ondemand") ? "On Demand":"Time Call"));
          let data = {
            "refID": (parseInt(confirmation)),
            "serviceID": (parseInt(serviceID) ?  parseInt(serviceID) : 0),
            "scheduleID": (parseInt(rowSelectedCheck[0].iScheduleID) ?  (parseInt(rowSelectedCheck[0].iScheduleID)) : (rowSelectedCheck[0].ScheduleID ? parseInt(rowSelectedCheck[0].ScheduleID) : 0)),
            "isSchedule": scheduled,
            "requestType": requestTypeVal
          };
          let response = await APICom.fetchData("ReservationCoreURL", "api/ParatransitCT/GetRequestForEdit", "post", { "Content-Type": "application/json" }, data, null);
          // console.log("Edit API", response);
          if (response && response.error === "") {
            if (response.data && response.data !== 'No data found') {
              PersistStorage.save("rowDataEditTrip", response.data, 999, true);
              // PersistStorage.save("selectedDate", props.selectedDate, 999, true);
              calltakerRef.current = window.open('/CallAgent?TripSelected=true', 'com_domain_callAgentScreen');
              PersistStorage.save("callAgentTabStatus", false, 999, true);
            }
            else {
              setModalHeaderText("Edit Info Error");
              setModalBodyHTML(<b>{"No data was found for the selected trip. Please contact the administrator for additional details."}</b>);
              setModalFooterHTML(
                <Button variant='secondary' className="border-0" onClick={() => setShowDynamicModal(false)}>
                  OK
                </Button>
              );
              setShowDynamicModal(true);
              PersistStorage.save("rowDataEditTrip", "", 999, true);
            }
          }
          else {
            setModalHeaderText("Edit Info Error");
            setModalBodyHTML(<b>{response.error}</b>);
            setModalFooterHTML(
              <Button variant='secondary' className="border-0" onClick={() => setShowDynamicModal(false)}>
                OK
              </Button>
            );
            setShowDynamicModal(true);
            PersistStorage.save("rowDataEditTrip", "", 999, true);
          }
        }

      }
    }
    catch (err) { console.log(err); }
  };

  const SendEmailToCustomer = async (data) => {
    try{
      let Param = {
        confirmationno: data["Confirmation #"],
        email: customerEmail
      };
      const globalInLoadAPIURL = (GlobalASCSData.find(dict => dict.SubTitle === "InLoadAPI_URL") ? GlobalASCSData.find(dict => dict.SubTitle === "InLoadAPI_URL").value : "");
      let fullEmailURL = globalInLoadAPIURL+"/TripReservation/SendTripEmailToCustomer"
      let response = await APICom.fetchData("full", fullEmailURL, "post", { "Content-Type": "application/json" }, Param, null);
      let result = response.data;
      if(result === 'Success')
      {
        setModalHeaderText("Email Receipt Alert");
        setModalBodyHTML(<p>{"Email sent successfully. "}</p>);
        setModalFooterHTML(
          <Button variant="dark" className="mx-1 border-0" onClick={()=>setShowDynamicModal(false)}>
          {"OK"}
          </Button>
        );
        setShowDynamicModal(true);
        setCustomerEmail("");
      }
      else
      {
        setModalHeaderText("Email Receipt Alert");
        setModalBodyHTML(<p>{"Email not sent. Please try again later. "}</p>);
        setModalFooterHTML(
          <Button variant="dark" className="mx-1 border-0" onClick={()=>setShowDynamicModal(false)}>
          {"OK"}
          </Button>
        );
        setShowDynamicModal(true);
        setCustomerEmail("");
      }
    }
    catch(err){console.log(err);}
  };

  const handleInvokeSidebarToggle = (e) =>{
    try{
      setMenuSidebar(prevCheck => !prevCheck);
      menuTracker.current = true;
      props.setSideBarStatus(true);
      handleOpenSidebar();
    }
    catch (err) { console.log(err); }
  };

  const handleOpenSidebar = () => {
    try {
      if (menuTracker.current) {
        // console.log("open");
        navBarRef.current.classList.add('navBarStyle');
        let gridContainer = document.getElementById(tableOptionsRef.current.GridName + "_container");
        let mapContainer = document.getElementById(tableOptionsRef.current.GridName + '_mapContainer');
        let clusterContainer = document.getElementById("clusterTableGrid_container");
        if (mapBtnRef.current.textContent === "Map") {
          gridContainer.classList.add('gridClosedMapStyle');
        }
        else {
          gridContainer.classList.add('gridOpenMapStyle');
          //mapContainer.classList.add('mapOpenStyle');
          clusterContainer.classList.add('mapOpenStyle');
        }
      }
    }
    catch (err) { console.log(err); }
  };

  function handleInvokeCancelTrip () {
    
    if(tableOptionsRef.current && tableOptionsRef.current.GridName === 'standingOrder')
    {
      let rowData = PersistStorage.retrieve("rowDataCallAgent", true);
      if(rowData && rowData.length > 0)
      {
        let confirmation = rowData[0]["Confirmation #"];
        let name = rowData[0].PickupPerson;
        setGivenDynamicModalSize('lg');
        setModalHeaderText("Confirm Cancel");
        setModalBodyHTML(<p>{"Request with confirmation # "}<b>{"'"+confirmation+"'"}</b>{" and pickup person "}
            <b>{"'"+name+"'"}</b>{" is a "}<span className='text-danger fw-bold'>{"multi-schedule"}</span>{". Click 'Yes' to cancel the whole schedule."}</p>
        );
        setModalFooterHTML(
            <>
              <Button variant="dark" className="mx-1 border-0" onClick={()=>{setShowDynamicModal(false); props.initiateCancel(true);}}>
                {"Yes"}
              </Button>
              <Button variant="secondary" className="mx-1 border-0" onClick={()=>{setShowDynamicModal(false);}}>
                {"No"}
              </Button>
            </>
        );
        setShowDynamicModal(true);
      }
    }
    else
    {
      props.initiateCancel(true);
    }
  }

  function handleInvokeActivateTrip() {
    props.initiateActivate(true);
  }

  function handleInvokeCallAgent() {
    try {
      calltakerRef.current = window.open('/CallAgent', 'com_domain_callAgentScreen');
      // PersistStorage.save("selectedDate", props.selectedDate, 999, true);
      PersistStorage.save("rowDataEditTrip", "", 999, true);
      PersistStorage.save("clientInfo", [], 99, true);
      PersistStorage.save("callAgentTabStatus", false, 999, true);
    }
    catch (err) { console.log(err); }
  }

  function handleInvokeCopyTripCallAgent () {
    try{
      const rowSelectedCheck = PersistStorage.retrieve("rowDataCallAgent", true);
      // if(rowSelectedCheck && rowSelectedCheck.length > 0) //Upcoming feature
      // {
      //   if(rowSelectedCheck.length === 1)
      //   {


      //   }
      // }
      // else
      // {
      //   //No trip selected
      //   setModalHeaderText("No Trip Selected");
      //   setModalBodyHTML(<b>{"Please select a trip to copy."}</b>);
      //   setModalFooterHTML(
      //     <Button variant='secondary' className="border-0" onClick={()=>setShowDynamicModal(false)}>
      //       OK
      //     </Button>
      //   );
      //   setShowDynamicModal(true);
      // }

      setModalHeaderText("Upcoming Feature");
      setModalBodyHTML(<p><b>{"Copy Ride"}</b>{" is a work in progress and will be available in an upcoming release."}</p>);
      setModalFooterHTML(
          <Button variant="dark" className="mx-1 border-0" onClick={()=>setShowDynamicModal(false)}>
          {"OK"}
          </Button>
      );
      setShowDynamicModal(true);
      props.setCallTakerDisp('None');
    }
    catch(err){console.log(err);}
  }

  function handleInvokeEditTripCallAgent () {
    try{
      if(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2)
      {
        const rowSelectedCheck = PersistStorage.retrieve("rowDataCallAgent", true);
        if (rowSelectedCheck && rowSelectedCheck.length > 0) {
          if (rowSelectedCheck.length === 1) {
            let clientInfoData = PersistStorage.retrieve("clientInfo", true);
            let tabClosed = PersistStorage.retrieve("callAgentTabStatus", true);
            if (!Array.isArray(clientInfoData)) {
              setModalHeaderText("Edit Request");
              setModalBodyHTML(<b>{"A request is already under process. Do you still want to edit this request?"}</b>);
              setModalFooterHTML(
                <>
                  <Button variant='dark' className="border-0" onClick={() => { setShowDynamicModal(false); handleCheckSelectedTrip(rowSelectedCheck); }}>
                    Yes
                  </Button>
                  <Button variant='secondary' className="border-0" onClick={() => { setShowDynamicModal(false); }}>
                    No
                  </Button>
                </>
              );
              setShowDynamicModal(true);
            }
            else {
              handleCheckSelectedTrip(rowSelectedCheck);
            }
          }
          else {
            //Multiple Trips selected
            setModalHeaderText("Multiple Trips Selected");
            setModalBodyHTML(<b>{"Please select a single trip to edit."}</b>);
            setModalFooterHTML(
              <Button variant='secondary' className="border-0" onClick={() => setShowDynamicModal(false)}>
                OK
              </Button>
            );
            setShowDynamicModal(true);
          }
        }
        else {
          //No trip selected
          setModalHeaderText("No Trip Selected");
          setModalBodyHTML(<b>{"Please select a trip to edit."}</b>);
          setModalFooterHTML(
            <Button variant='secondary' className="border-0" onClick={() => setShowDynamicModal(false)}>
              OK
            </Button>
          );
          setShowDynamicModal(true);
        }
      }
    }
    catch (err) { console.log(err); }
  };

  function handleInvokeTripActions() {
    props.setShowTripActionsDialog(true);
  }

  function handleInvokeTripActionsFromManifestNumber(show = false, item) {
    props.setShowTripActionsDialogForManifestNumber(show, item);
  }

  function handleInvokeDriverActions() {
    try {
      props.setDriverActionsDialog(true);
      DispatchMainToolbarPersistStorage("DriverActionsDialog", true);
    }
    catch (err) { console.log(err); }
  }

  function handleInvokeGroupingActions() {
    props.setShowGroupingActionDialog(true);
  }

  function handleInvokeVehicleTracking() {
    props.initiateVehicleTracking(true);
  }

  function handleInvokeAgileDispatch() {
    props.initiateAgileDispatch(true);
  }

  function handleInvokeUpdateCallback() {
    props.initiateUpdateCallback(true);
  }

  function handleBrokerActions() {
    props.setBrokerActionsDialog(true);
  }

  function handleTripInformation() {
    try {
      const rowSelectedCheck = PersistStorage.retrieve("rowDataCallAgent", true);
      if(rowSelectedCheck)
      {
        if (rowSelectedCheck.length > 1) {
          setModalHeaderText("Trip Details Alert");
          setModalBodyHTML(<p>{"Please select a single trip to edit."}</p>);
          setModalFooterHTML(
            <Button variant="dark" className="mx-1 border-0" onClick={() => setShowDynamicModal(false)}>
              {"OK"}
            </Button>
          );
          setShowDynamicModal(true);
        }
        else if (rowSelectedCheck.length === 1) {
          DispatchMainToolbarPersistStorage("TripDetailsDialog", true);
          props.setTripDetailsDialog(true);
        }
      }
      
    }
    catch (err) { console.log(err); }
  }

  function handleSpeedZoneMultiplier() {
    try {
      window.open('/ZoneSpeedMultiplier', 'com_domain_SZMScreen');
    } catch (err) {
      console.log(err);
    }
  }

  function handleMTDiagnostic() {
    props.setMTDiagnosticDialog(true);
  }

  function handleAgentNotesAction () {
    try{
      props.setAgentNotesDialog(true);
    }
    catch(err){console.log(err);}
  }

  function handleAddUpdateExtraInfo () {
    try{
      let selectedRow = PersistStorage.retrieve("rowDataCallAgent", true);
      setModalHeaderText("Upcoming Feature");
        setModalBodyHTML(<p><b>{"Add/Update Extra Info"}</b>{" is a work in progress and will be available in an upcoming release."}</p>);
        setModalFooterHTML(
          <Button variant="dark" className="mx-1 border-0" onClick={()=>setShowDynamicModal(false)}>
          {"OK"}
          </Button>
        );
        setShowDynamicModal(true);
    }
    catch (err) { console.log(err); }
  }

  function handleSendEmail () {
    try{
      let selectedRow = PersistStorage.retrieve("rowDataCallAgent", true);
      if(selectedRow)
      {
        if(selectedRow.length > 1)
        {
          setModalHeaderText("Email Receipt Alert");
          setModalBodyHTML(<p>{"You have selected "}<b>{selectedRow.length}</b>{" trips, please select a single trip to perform this action."}</p>);
          setModalFooterHTML(
              <Button variant="dark" className="mx-1 border-0" onClick={()=>setShowDynamicModal(false)}>
              {"OK"}
              </Button>
          );
          setShowDynamicModal(true);
        }
        else
        {
          let data = selectedRow[0];
          setSendEmailDict({showCustomerEmailRequest: true, customerTripData: data});
        }
      }
      
    }
    catch(err){console.log(err);}
  }

  async function handleShowMultiSchAction() {
    try {
      const rowSelectedCheck = PersistStorage.retrieve("rowDataCallAgent", true);
      if(rowSelectedCheck) {
        if (rowSelectedCheck.length > 1) {
          setModalHeaderText("Multi-Schedule Report Alert");
          setModalBodyHTML(<p>{"Please select a single trip to view report."}</p>);
          setModalFooterHTML(
            <Button variant="dark" className="mx-1 border-0" onClick={() => setShowDynamicModal(false)}>
              {"OK"}
            </Button>
          );
          setShowDynamicModal(true);
        }
        else if (rowSelectedCheck.length === 1) {
          await ShowMultiSchData(rowSelectedCheck[0]["Confirmation #"]);
        }
      }
    }
    catch (err) { console.log(err); }
  }

  function handleInvokeClusteringActions() {
    props.setShowClusterDialog(true);
  }

  function handleInvokeBuildManifestActions() {
    props.setManifestBuildDialog(true);
  }

  function handleInvokeShowRoutes() {
    props.setShowRoutesDialog(true);
  }

  function handleInvokeRBSProcessActions() {
    props.setRBSProcessDialog(true);
  }

  function handleStandingRouteActions() {
    props.setStandingRouteDialog(true);
  }

  const handleRouteSettingEdit = (e) => {
    try {
      editRouteSetDataRef.current = [];
      let data = clusterComboData.current.find((item) => item.vVirtualRoute === e.target.dataset.virtual);
      editRouteSetDataRef.current = data;
      setInvokeEditRouteSettings(true);
    }
    catch (err) { console.log(err); }
  };

  const addHandleRouteSettingsEditPencil = (element) => {
    try {
      if (element && !HandleRouteSettingsEditPencil.includes(element)) {
        setHandleRouteSettingsEditPencil(prevRefs => [...prevRefs, element]);
      }
    }
    catch (err) { console.log(err); }
  };



  const handleSaveSelectionForDateAPI = async (routeSelected, routeCheckFlag) => {
    try {
      let routeCheckFlagCheck = routeCheckFlag ? 1 : 0;
      let checkItem = updateCheckDays.find((item) => Object.keys(item)[0] === routeSelected);
      let index = updateCheckDays.findIndex(item => item.hasOwnProperty(routeSelected));
      if (Object.values(checkItem)[0] !== routeCheckFlagCheck) {
        updateCheckDays[index][routeSelected] = routeCheckFlagCheck;
        setUpdateCheckDays(updateCheckDays);
      }
      let data = clusterComboData.current.find((item) => item.vVirtualRoute === routeSelected);
      let date = data.dtRouteStartTime.split("T")[0];
      let selectedRoutes = "";
      let unSelectedRoutes = "";
      let selectedDepots = "";
      let selectedVeh = "";
      for (let k = 0; k < updateCheckDays.length; k++) {
        if (Object.values(updateCheckDays[k])[0]) {
          selectedRoutes += Object.keys(updateCheckDays[k])[0] + ",";
          let tempData = clusterComboData.current.find((item) => item.vVirtualRoute === Object.keys(updateCheckDays[k])[0]);
          selectedDepots += String(tempData.iDepot) + ",";
          selectedVeh += String(tempData.iVehicleID) + ",";
        }
        else {
          unSelectedRoutes += "'" + Object.keys(updateCheckDays[k])[0] + "',";
        }

      }
      let params = {
        "vSettingName": data.vSettingName,
        "dtSelectedDate": date,
        "iSettingID": parseInt(data.iSettingID),
        "selectedRoutes": selectedRoutes,
        "selectedVehicle": selectedVeh,
        "selectedDepots": selectedDepots,
        "unSelectedRoutes": unSelectedRoutes,
        "currentlySelectedRoute": routeSelected,
        "isDay": routeCheckFlag,
        "userID": loginData.iUserID,
        "appID": 26
      }
      let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/SaveSelectedDaysForDate", "post", { "Content-Type": "application/json" }, params, null);
      let result = response.data;
      if (result !== null && result.length > 0) {
        if (result[0].Result.toUpperCase() !== "FAILED") {
          APICallRef.current = false;
        }
      }
    }
    catch (err) { console.log(err); }
  };

  const handleDayCheckRef = (e) => {
    try {
      e.stopPropagation();
      // setIsCheckedForRouteDropDown(e.target.checked);
      setUpdateCheckDays(prevState => {
        let newState = prevState;//{...prevState};
        let index = prevState.findIndex(item => item.hasOwnProperty(e.target.dataset.virtual));
        newState[index][e.target.dataset.virtual] = e.target.checked ? 1 : 0;
        return newState;
      });
      handleSaveSelectionForDateAPI(e.target.dataset.virtual, e.target.checked);
    }
    catch (err) { console.log(err); }
  };

  const handleCheckForDay = (e) => {
    try {
      if (e && !HandleRouteCheckDays.includes(e)) {
        setHandleRouteCheckDays(prevRefs => [...prevRefs, e]);
      }
    }
    catch (err) { console.log(err); }
  };
  const CheckIFArbIsCheckedOnGuiForAffiliate = async (affiliateId) => {
    try {
      if(affiliateId != "") {
        let affSelection = (String(affiliateId).includes(",") ? String(affiliateId).split(",")[0] : affiliateId);
        let ArbCheckedOnGuiresponse = await APICom.fetchData("", "TripActions/checkIsARBCheckedOnGuiByATSPID?iAffiliateID=" + affSelection, "get", {"Content-Type": "application/json"}, null, null);
        // const iTransType = Number(ArbCheckedOnGuiresponse?.data?.iTransType);
        // if (isNaN(iTransType)) 
        //   {
        //     iTransType = 0;
        //   }

        if (ArbCheckedOnGuiresponse.data.bARBCheckedOnGUI !== undefined && ArbCheckedOnGuiresponse.data.bARBCheckedOnGUI !== null) {
          ArbCheckedOnGuiRef.current = ArbCheckedOnGuiresponse.data.bARBCheckedOnGUI
          let grpOpt = []
          setrouteFilterMultiSelect({...clusterFilterMultiSelect, options: grpOpt, selectedValues: []});
        }else{
          ArbCheckedOnGuiRef.current = true
        }
        //await showDropDownOptions({Given: "AFFILIATE", Value: affSelection});
        //props.setDropDownRoute(props.selectedRoute);
        setrouteFilterMultiSelect({ ...clusterFilterMultiSelect, ...{ selectedValues: GetClusterSelectObjectBy(props.selectedRoute) } });
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    //CheckIFArbIsCheckedOnGuiForAffiliate(ToolboxValues.AffiliatesList);
  }, [ToolboxValues.AffiliatesList]);

//   useEffect(() => {
//   let intervalId = setInterval(() => CheckIFArbIsCheckedOnGuiForAffiliate(affSelectedRef.current), 120000);
//   return () => {
//     clearInterval(intervalId);
//   };
// }, []);

//const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));
  const showDropDownOptions = async (data) => {
    try {
      // if(document.getElementById(props.options.GridName+'_mapViewBtn').textContent.toUpperCase() === "BACK")
      // {
      if(IsGetAllTodayRoutesCallInProgress.current){
        return;
      }

      await CheckIFArbIsCheckedOnGuiForAffiliate(ToolboxValues.AffiliatesList);

      const set = new Set();
      let groupOptions = [];
      let checkDaysArr = [];
      let tempDict = {};
      let status = null;
      let affID = "";//(ToolboxValues.AffiliatesList.includes(",") ? ToolboxValues.AffiliatesList.split(",")[0]:ToolboxValues.AffiliatesList);
      let dataObj = null;
      if (data.Given === "COMPANY") {
        let familyID = (Array.isArray(data.Value) ? data.Value[0] : data.Value);
        dataObj = AffiliateData.find(item => String(item.DTSPID) === familyID.toString());
        dataObj = (dataObj ? dataObj : AffiliateData[0]);
        affID = String(dataObj.AffiliateID);
      }
      else if (data.Given === "AFFILIATE") {
        let affIDSelected = (Array.isArray(data.Value) ? data.Value[0] : data.Value);
        affID = String(affIDSelected);
      }
      affiliateRef.current = affID;
      let date = ToolboxValues.Date;
      let storageDate = null
      let parsedData = null
      let newDate = null
      const dateFromStorage = localStorage.getItem('selectedDate');
      if (dateFromStorage) {
        parsedData = JSON.parse(dateFromStorage);
        storageDate = parsedData?.data
      }
      newDate = storageDate ? storageDate : date;
      if (new Date(newDate) < new Date(date)) {
        newDate = date
      }
      setNewDateOnEditRoute(newDate)
      const [year, month, day] = newDate?.split('-');
      let formattedDate = `${month}/${day}/${year}`;
      // const formattedDate = new Date(newDate).toLocaleDateString('en-GB', {
      //   day: '2-digit',
      //   month: 'short',
      //   year: 'numeric',
      // });

      if(affID !== "")
        {
          let filteredData= AffiliateData.filter(item => String(item.AffiliateID) === affID);
          if (filteredData.length > 0 && ArbCheckedOnGuiRef.current) {
            let iTransTypeValue = '0';
            if (filteredData[0].iTransType !== undefined && filteredData[0].iTransType !== null) {
              iTransTypeValue = String(filteredData[0].iTransType);
            }
            IsGetAllTodayRoutesCallInProgress.current = true;
            let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/GetAllTodaysRoutes?selected_date=" + newDate + "&affiliate_id=" + affID + "&iTransType=" + iTransTypeValue + "&bMainTables=true" , "get", {"Content-Type": "application/json"}, null, null);
            //await delay(5000);
            IsGetAllTodayRoutesCallInProgress.current = false;
            // console.log("for aff ", affID, response);
            if (response.data) {
              clusterComboData.current = response.data;
              clusterComboDataBackup.current = response.data;
              // console.log(clusterComboData.current);
            } else {
              setrouteFilterMultiSelect({...clusterFilterMultiSelect, options: groupOptions, selectedValues: ""});
              setShowRouteDropDown(true);
              clusterComboData.current = [];
              clusterComboDataBackup.current = [];
            }
            // console.log("cluster data", clusterComboData.current);
            if (clusterComboData.current !== undefined && clusterComboData.current.length !== 0 ) {
              clusterComboData.current?.forEach((data) => {
                let checkforDays = (String(data.SelectedForTheDay) === "false" || String(data.SelectedForTheDay) === "0" ? 0 : 1);
                tempDict = {};
                tempDict[data.vVirtualRoute] = checkforDays;
                checkDaysArr.push(tempDict);
              });
              setUpdateCheckDays(checkDaysArr);
              clusterComboData.current?.forEach((data, index) => {
                if (data.vVirtualRoute && !set.has(data.vVirtualRoute)) {
                  set.add(data.vVirtualRoute);

                  let isRouteCompleted = false;
                  if (data?.RouteStatus.toUpperCase().includes("ACCEPTED")
                      || data?.RouteStatus.toUpperCase().includes("ASSIGN")
                      || data?.RouteStatus.toUpperCase().includes("OFFERED") || data?.RouteStatus.toUpperCase().includes("SCHEDULE")) {
                    status = Dispatched;
                  } else if (data?.RouteStatus.toUpperCase().includes("DROP") || data?.RouteStatus.toUpperCase().includes("TREATED")
                      || data?.RouteStatus.toUpperCase().includes("COMPLETE")) {
                    status = Completed;
                    isRouteCompleted = true;
                  } else if (data?.RouteStatus.toUpperCase().includes("PICKED") || data?.RouteStatus.toUpperCase().includes("IRTPU")
                      || data?.RouteStatus.toUpperCase().includes("PROGRESS")) {
                    status = IRTPU;
                  } else if (data?.RouteStatus.toUpperCase().includes("STARTED")) {
                    if (data?.RouteStatus.toUpperCase().includes("NOT")) {
                      status = InActive;
                    } else {
                      status = Active;
                    }
                  }
                  groupOptions.push({
                    "label":
                        <table className="w-auto" style={{height: "50px !important"}}>
                          <tbody>
                          <tr className="text-center text-nowrap" style={{width: "100%"}}>
                            
                          <td style={{maxWidth: "50px", width: "50px", fontSize: "small"}}
                                className="p-0 m-0 mx-1 user-select-none">
                              {data.RouteType === 'R' ? (
                                  <>
                                    <input
                                        type="checkbox"
                                        className="float-start mx-1 mt-1"
                                        style={{cursor: "pointer"}}
                                        onChange={handleDayCheckRef}
                                        checked={checkDaysArr[index][data.vVirtualRoute]}
                                        ref={handleCheckForDay}
                                        title="Check for Day"
                                        data-virtual={data.vVirtualRoute}
                                        disabled={data.iSettingID === -1}
                                    />
                                  </>
                              ) : (
                                  <>
                                    <input
                                        type="checkbox"
                                        className="float-start mx-1 mt-1"
                                        style={{cursor: "not-allowed", opacity: 0.5}}
                                        title="Not Available for This Route Type"
                                        disabled
                                    />
                                  </>
                              )}
                            </td>
                            <td style={{
                              maxWidth: "70px",
                              minWidth: "69px",
                              width: "70px !important",
                              fontSize: "x-small"
                            }}
                                title={data.vVirtualRoute} className="p-0 m-0 user-select-none overflow-hidden">
                              {data.vVirtualRoute}
                            </td>
                            <td style={{maxWidth: "40px", minWidth: "39px", width: "40px", fontSize: "x-small"}}
                                title={data.dtRouteStartTime.split("T")[1].slice(0, 5)}
                                className="p-0 m-0 px-1 mx-1 user-select-none">
                              {data.dtRouteStartTime === "" || data.dtRouteStartTime === null ? "-" : data.dtRouteStartTime.split("T")[1].slice(0, 5)}
                            </td>
                            <td style={{
                              maxWidth: "40px",
                              minWidth: "39px",
                              width: "40px !important",
                              fontSize: "x-small"
                            }}
                                title="Assigned Vehicle" className="p-0 m-0 px-1 mx-1 user-select-none overflow-hidden">
                              {data.OdAssignedVehicle === "" || data.OdAssignedVehicle === null
                                  ? data.AssignedVehicle === "" || data.AssignedVehicle === null
                                      ? "N/A"
                                      : data.AssignedVehicle
                                  : data.OdAssignedVehicle}
                            </td>
                            <td style={{maxWidth: "40px", minWidth: "39px", width: "40px", fontSize: "x-small"}}
                                className="p-0 m-0 px-1 mx-1 user-select-none">
                              {data.iTotalNoOfTrip}
                            </td>
                            <td style={{maxWidth: "40px", minWidth: "39px", width: "40px", fontSize: "x-small"}}
                                title={data.iTotalDistMile} className="p-0 m-0 px-1 mx-1 user-select-none">
                              {data.iTotalDistMile === "" || data.iTotalDistMile === null ? "0" : data.iTotalDistMile}
                            </td>
                            <td style={{maxWidth: "70px", minWidth: "39px", width: "70px", fontSize: "x-small"}}
                                title={data?.vTypeName === "" || data?.vTypeName === null || data?.vTypeName === undefined
                                ? data?.vName === "" || data?.vName === null ? "N/A": data?.vName
                                : data?.vTypeName}
                                className="p-0 px-1 text-start m-0 mx-1 user-select-none overflow-hidden">
                                  {data?.vTypeName === "" || data?.vTypeName === null || data?.vTypeName === undefined
                                  ? data?.vName === "" || data?.vName === null ? "N/A": data?.vName
                                  : data?.vTypeName}
                            </td>
                            <td style={{maxWidth: "40px", minWidth: "39px", width: "40px", fontSize: "x-small"}}
                                title={
                                  data.RouteType === 'R' ? 'Route' :
                                      data.RouteType === 'C' ? 'Cluster' :
                                          data.RouteType === 'B' ? 'Broker' :
                                              'Unknown'
                                } className="p-0 px-1 text-start m-0 mx-1 user-select-none overflow-hidden">
                              {data.RouteType === "" || data.RouteType === null ? "N/A" : data.RouteType}
                            </td>
                            <td style={{maxWidth: "50px", minWidth: "49px", width: "50px", fontSize: "x-small"}}
                                className="p-0 m-0 px-1 mx-1 user-select-none">
                              {data.RouteFCST}
                            </td>
                            <td style={{maxWidth: "50px", width: "50px", fontSize: "small"}}
                                className="p-0 m-0 mx-1 user-select-none">
                              {data.RouteType === 'R' ? (
                                  <>
                                    {/* <input
                                        type="checkbox"
                                        className="float-start mx-1 mt-1"
                                        style={{cursor: "pointer"}}
                                        onChange={handleDayCheckRef}
                                        checked={checkDaysArr[index][data.vVirtualRoute]}
                                        ref={handleCheckForDay}
                                        title="Check for Day"
                                        data-virtual={data.vVirtualRoute}
                                        disabled={data.iSettingID === -1}
                                    /> */}
                                    {(data.iSettingID === -1 || data?.RouteType === 'C') ? (
                                        <p
                                            className="m-0"
                                            style={{cursor: "default", opacity: 0.5}}
                                            title="Not Allowed"
                                            data-virtual={data.vVirtualRoute}
                                        >
                                          ✎
                                        </p>
                                    ) : (
                                        <p
                                            className="m-0"
                                            style={{cursor: "pointer"}}
                                            title="Edit Route Setting"
                                            data-virtual={data.vVirtualRoute}
                                            ref={addHandleRouteSettingsEditPencil}
                                            // onClick={yourOnClickFunction}
                                        >
                                          ✎
                                        </p>
                                    )}
                                  </>
                              ) : (
                                  <>
                                    {/* <input
                                        type="checkbox"
                                        className="float-start mx-1 mt-1"
                                        style={{cursor: "not-allowed", opacity: 0.5}}
                                        title="Not Available for This Route Type"
                                        disabled
                                    /> */}
                                    <p
                                        className="m-0"
                                        style={{cursor: "not-allowed", opacity: 0.5}}
                                        title="Not Available for This Route Type"
                                    >
                                      ✎
                                    </p>
                                  </>
                              )}
                            </td>

                            <td style={{maxWidth: "50px", width: "50px", fontSize: "x-small"}}
                                className="p-0 m-0 mx-1 px-3 user-select-none">
                              <img src={status} style={{width: "16px", height: "16px"}} className='mx-1'
                                   title={data.RouteStatus}/>
                            </td>
                            <td style={{maxWidth: "80px", width: "80px", fontSize: "x-small"}}
                                className="p-0 m-0 mx-1 px-3 user-select-none">
                                  <Button
                                    variant="success"
                                    size="sm"
                                    className="border-0"
                                    title="Dispatch Route"
                                    style={{ visibility: data.iTotalNoOfTrip > 0 && !isRouteCompleted? "visible" : "hidden" }}
                                    onClick={(e) => 
                                      {
                                        e.stopPropagation();
                                        RedirectToTripActions(data)
                                      }
                                    }>
                                    Dispatch
                                  </Button>
                            </td>
                          </tr>
                          </tbody>
                        </table>,
                    "value": data.vVirtualRoute
                  })
                }
              });
            }
            if (groupOptions.length > 0) {
              groupOptions = [{
                "label":
                    <table className="w-auto" style={{height: "50px !important"}}>
                      <thead>
                      <tr>
                        <th style={{fontSize: "small"}} colSpan="9" className="text-center" title={"Date"}>
                          {formattedDate}
                        </th>
                      </tr>
                      <tr className="text-center text-nowrap">
                        <th style={{width: "70px", fontSize: "small"}} className="px-2 user-select-none">
                        </th>
                        <th style={{width: "70px", fontSize: "small"}} className="px-2 user-select-none"
                            title={"Route"}>
                          {"Route"}
                        </th>
                        <th style={{width: "50px", fontSize: "small"}} className="px-2 user-select-none"
                            title={"Route Start Depot Time"}>
                          {"S-Time"}
                        </th>
                        <th style={{width: "50px", fontSize: "small"}} className="px-2 user-select-none" title={"Veh#"}>
                          {"Veh#"}
                        </th>
                        <th style={{width: "50px", fontSize: "small"}} className="px-1 user-select-none"
                            title={"Trips"}>
                          {"Trips"}
                        </th>
                        <th style={{width: "50px", fontSize: "small"}} className="px-1 user-select-none"
                            title={"Service Miles from SDepot to EDepot "}>
                          {"Dist"}
                        </th>
                        <th style={{width: "70px", fontSize: "small"}} className="px-1 user-select-none"
                            title={"Vehicle Type"}>
                          {"Type"}
                        </th>
                        <th style={{width: "50px", fontSize: "small"}} className="px-1 user-select-none"
                            title={"Route Type"}>
                          {"R-Type"}
                        </th>
                        <th style={{width: "50px", fontSize: "small"}} className="px-1 user-select-none" title={"FCST"}>
                          {"FCST"}
                        </th>
                        <th style={{width: "50px", fontSize: "small"}} className="px-1 user-select-none"
                            title={"Edit Route"}>
                          {"Edit"}
                        </th>
                        <th style={{width: "50px", fontSize: "small"}} className="px-1 user-select-none"
                            title={"Route Status"}>
                          {"Status"}
                        </th>
                        <th style={{width: "80px", fontSize: "small"}} className="px-1 user-select-none"
                            title={"Dispatch Route"}>
                          {"Dispatch"}
                        </th>
                      </tr>
                      </thead>
                    </table>, "value": "info"
              }].concat(groupOptions);
            }
            setrouteFilterMultiSelect({
              ...clusterFilterMultiSelect,
              options: groupOptions,
              selectedValues: groupOptions.length > 0 ? groupOptions[0].value : ""
            });

          }
          else {
            groupOptions = [{
              "label":
                  <table className="w-auto" style={{height: "50px !important"}}>
                    <thead>
                      <tr>
                        <th style={{ fontSize: "small" }} colSpan="9" className="text-center" title={"Routing Disabled"}>
                          Routing is disabled for the Affiliate
                        </th>
                      </tr>
                    </thead>
                  </table>, "value": "routing_disabled"
            }]
            setrouteFilterMultiSelect({...clusterFilterMultiSelect, options: groupOptions, selectedValues: groupOptions.length > 0 ? groupOptions[0].value :"" });
          }
          setShowRouteDropDown(true);
        }
      // }
    }
    catch (err) { console.log(err);
      IsGetAllTodayRoutesCallInProgress.current = false;
    }
  };

  const RedirectToTripActions = (item) => {
    try {
      handleInvokeTripActionsFromManifestNumber(true, item);
    } catch (error) {
      
    }
  }

  const handleClusterTripsLoad = async (val) => {
    try {
      props.setIsFromDoubleClick(true)
      let actualData = clusterComboDataBackup.current.find((item) => item.vVirtualRoute === val);
      let affID = (ToolboxValues.AffiliatesList.includes(",") ? ToolboxValues.AffiliatesList.split(",")[0] : ToolboxValues.AffiliatesList);
      let date = ToolboxValues.Date;
      
      let params = {};
      props.setSelectedRoute(actualData.vManifestNumber, actualData?.iTotalNoOfTrip);
      props.setDropDownRoute(val);
 
      if(showCompltdTrips === true){
        showCompletedCheckRef.current = true;
      }
      else{
        showCompletedCheckRef.current = false;
      }

      if (actualData.vManifestNumber === '' || actualData.vManifestNumber === null || actualData.vManifestNumber === undefined) {
        params = {
          "vManifestNumber": actualData.vVirtualRoute,
          "dtSelectedDate": date,
          "vehicleId": -1,
          "bIncludePerformed": showCompletedCheckRef.current,
          "vAffIDs": String(affID),
          "confirmationNo": "",
          "iDepotID": actualData.iDepot,
          "iFetchMode": 2,
          "iSettingID": String(actualData.iSettingID)
        }

      }
      else if (actualData.vManifestNumber != '') {
        params = {
          "vManifestNumber": actualData.vManifestNumber,
          "dtSelectedDate": date,
          "vehicleId": -1,
          "bIncludePerformed": showCompletedCheckRef.current,
          "vAffIDs": String(affID),
          "confirmationNo": "",
          "iFetchMode": 0,
          "GridName": "SelectedGridRouteSRQARQPRQ_NewC",
          "iUserID": loginData.recordID
        }
      }

      let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/GetRouteStopView", "post", { "Content-Type": "application/json" }, params, null);
      let result = response.data;
      if (result !== null && result.data && result.data.length > 0) {
        // console.log(result);
        let IsRoutedStopView = result.data[1]?.Route;
        let AssignedVeNo = result.data[1]?.VehNo;

        if (IsRoutedStopView) {
            let currentDate = DateTimeUtils.getCurrentDate();
          if (date === currentDate){

            if (AssignedVeNo && AssignedVeNo !== "" && AssignedVeNo !== null && AssignedVeNo !== undefined) {

              let APIdata = {
                "TripNo": String(result.data[1].TripNo)
              }
              // await APICom.fetchData("main", "TripActions/GetVehicleAssignedToTripByConf", "post", {}, APIdata, null).then((response) => {
              //   let vehData = response.data
              //   if (vehData && vehData.length === 1) {
              //     props.updateVehData([]);
              //     props.updateVehData(response.data);

              //   }
              // });
            }
            else {
              let APIdata = {
                "pulat": result.data[1].dLatitude,
                "pulong": result.data[1].dLongitude,
                "nwheelchairs": String(result.data[1].iTotalWheelChairs),
                "iatspid": String(result.data[1].iAffiliateID),
                "bshowoccupiedvehicles": "false",
                "irefid": String(result.data[1].TripNo),
              }
              await APICom.fetchData("main", "TripActions/getnearbyvehicles", "post", {}, APIdata, null).then((response) => {
                props.updateVehData([]);
                props.updateVehData(response.data);
              });

            }

          }

          else {
            props.updateVehData([]);

          }

          props.setDetailDataFunc([]);
          props.setDetailDataFunc(result.data);
          props.setSettings(result.setting);
        }
        else {
          props.updateVehData([]);
          props.setDetailDataFunc([]);
          props.setDetailDataFunc(result.data);
          props.setSettings(result.setting);
        }
      }
      else {
        props.updateVehData([]);
        props.setDetailDataFunc([]);
        props.setSettings(result.setting);
      }
    }
    catch (err) { console.log(err); }
  };

  const handleNewMapView = () => {

  };
 

  let isProcessing = false;
  const handleMapView = (mode = '') => {
      
    if (isMapToggling) return;
    if (isProcessing) return;
    setTimeout(() => setIsMapToggling(false), 500);
    isProcessing = true;
    requestAnimationFrame(() => {
      try {
        let gridContainer = document.getElementById(tableOptionsRef.current.GridName + "_container");
        let clusterContainer = document.getElementById("clusterTableGrid_container");
        let mapContainer = document.getElementById(tableOptionsRef.current.GridName + "_mapContainer");

        if (!mapBtnRef.current) {
          isProcessing = false;
          return;
        }

        const isMapMode = (mode === 'aff' ? false : (mapBtnRef.current.textContent === "Map"));
        mapBtnRef.current.textContent = isMapMode ? "Hide Map" : "Map";
        mapBtnRef.current.title = isMapMode ? "Grid View" : "Map View";
        if(isMapMode){
          //props.setIsMainMapOpened(true);
        }
        else{
          //props.setIsMainMapOpened(false);
        }
        
        if(mapBtnRef.current.textContent !== 'Map' && mainGridType === 'Dispatch'){
          let iTransType = parseInt(transitTypeRef.current[0].iTransType) == 0 ? true : false;
          handleCheckCompleted2(iTransType/*isMapMode*/);
        }
        else{
          handleCheckCompleted2(isMapMode);
        }

        if (gridContainer) {
          gridContainer.classList.toggle("col-6", isMapMode);
          gridContainer.classList.toggle("d-inline-flex", isMapMode);
          gridContainer.classList.toggle("float-start", isMapMode);
          gridContainer.classList.toggle("col", !isMapMode);
        }


        if (document.getElementById("sidebar")?.classList.contains("open")) {
          if (gridContainer) {
            if(isMapMode){
              gridContainer.classList.add("gridOpenMapStyle");
              gridContainer.classList.remove("gridClosedMapStyle");
            } else {
              gridContainer.classList.remove("gridOpenMapStyle");
              gridContainer.classList.add("gridClosedMapStyle");
            }
            
          }

          if (mapContainer) {
            if(isMapMode)
              mapContainer.classList.add("mapOpenStyle");
            else
              mapContainer.classList.remove("mapOpenStyle");
          }
          if (clusterContainer) {
            clusterContainer.classList.toggle("mapOpenStyle", isMapMode);
          }
        }
        else
        {
          let isRowDataNotGiven = !mainGridRowData.current;
          let isManifestGiven = (mainGridRowData.current ? 
            (mainGridRowData.current.vManifestNumber && mainGridRowData.current.vManifestNumber !== '' ? true : 
              (mainGridRowData.current.ManifestNo && mainGridRowData.current.ManifestNo !== '' ? true : false)
            ) : false
          );

          if((isRowDataNotGiven || isManifestGiven) && clusterContainer && mapBtnRef.current.textContent === 'Map')
          {
            props.setDetailDataFunc([]);
            // console.log(mainGridRowData.current);
            props.handleMapHeight(100);
            props.setSettings({});
          }
        }

        props.handleMapMode(isMapMode);
      } catch (err) {
        console.log(err);
      } finally {
        isProcessing = false; // Allow next click
      }
    });
  };

  const selectedRouteFromDropDowon = useRef(props.selectedRoute);

  const RouteSelectCallback = async (_val) => {
    // console.log(mapBtnRef);
  setTimeout(async () => {
      if (mapBtnRef.current.textContent === "Map") {
        mapBtnRef.current.click();
      }
  
      // console.log(_val);
      if (_val !== "info") {
        //await handleClusterTripsLoad(_val);
      }
  
      if (_val !== "") {
        selectedRouteFromDropDowon.current = _val;
        setrouteFilterMultiSelect({ ...clusterFilterMultiSelect, ...{ selectedValues: GetClusterSelectObjectBy(_val) } });
      }
      else {
        setrouteFilterMultiSelect({ ...clusterFilterMultiSelect, ...{ selectedValues: [] } });
      }

      props.setSelectedRowFromRouteDropDown(_val);

  }, 100);

    //props.setDropDownRoute(_val);
  }
  const GetClusterSelectObjectBy = (_vVal) => {
    try {
      let groupOptions = [];
      for (let ii = 0; ii < clusterComboData.current.length; ii++) {
        if (_vVal.includes(clusterComboData.current[ii].vVirtualRoute)) {
          groupOptions.push({
            "label": clusterComboData.current[ii].vVirtualRoute,
            "value": clusterComboData.current[ii].vVirtualRoute
          });
          //groupOptions.push({ "label": clusterComboData.current[ii].vVirtualRoute, "value": (clusterComboData.current[ii].vManifestNumber+"_"+clusterComboData.current[ii].vVirtualRoute) });
          break;
        }
      }
      return groupOptions;
    }
    catch (err) { console.log(err); }
  }

  function handleSetGroupingHeader(e) {
    props.setGroupingFilter(e.target.value);
  }

  function handleUserInput(e) {
    let elements = document.getElementsByClassName('sidebarOptionClass');
    for (let i = 0; i < elements.length; i++) {
      if (elements[i].children[0].textContent.toLowerCase().includes("driver")) {
        if (e.target.value.toLowerCase().includes("admin")) {
          elements[i].style.display = "block";
        }
        else if (e.target.value.toLowerCase().includes("color")) {
          elements[i].style.display = "block";
        }
        else if (elements[i].children[0].textContent.toLowerCase().includes(e.target.value.toLowerCase())) {
          elements[i].style.display = "block";
        }
        else {
          elements[i].style.display = "none";
        }
      }
      else {
        if (!elements[i].children[0].textContent.toLowerCase().includes(e.target.value.toLowerCase())) {
          elements[i].style.display = "none";
        }
        else {
          elements[i].style.display = "block";
        }
      }

    }
  }

  function handleInvokeTripHistoryActions() {
    props.setTripHistoryDialog(true);
  }

  const handleRouteDropDownClick = async (e) => {
    try {
      let tagList = ["svg", "path"];
      let userSelectedObjClass = (e.target.tagName !== "svg" && e.target.tagName !== "path" ? e.target.className : "");
      userSelectedObjClass = userSelectedObjClass.replace(/\s/g, '');
      let classList = ["css-1fdsijx-ValueContainer", "css-qbdosj-Input", "css-15lsz6c-indicatorContainer"];
      // if (affChangeFlagRef.current !== String(props.selectedAffiliates) && (classList.includes(userSelectedObjClass) || tagList.includes(e.target.tagName))) {
        let affSelection = (ToolboxValues.AffiliatesList.includes(",") ? ToolboxValues.AffiliatesList.split(",")[0] : ToolboxValues.AffiliatesList);
        clusterComboData.current = [];
        if(IsGetAllTodayRoutesCallInProgress.current){
          clusterComboData.current = [];
          clusterComboDataBackup.current = [];
          let groupOptions = [];
          groupOptions.push({
            "label": "Loading Routes, Please wait...",
            "value": "Loading Routes, Please wait..."
          });
          setrouteFilterMultiSelect({...clusterFilterMultiSelect, options: groupOptions, selectedValues: ""});
          setShowRouteDropDown(true);
        }
        else{
          setShowRouteDropDown(true);
          clusterComboData.current = "[]";
          clusterComboDataBackup.current = "[]";
          await showDropDownOptions({ Given: "AFFILIATE", Value: affSelection });
        }
      // }
    }
    catch (err) { console.log("here 3".err); }
  };

  const handleCheckCompleted = (e) => {
    try {
      if (e.target.checked) {
        props.handleClusterReload(mainGridRowData.current, true);
        props.setCheckCompletedTrips(true);
        showCompletedCheckRef.current = true;
      }
      else {
        props.handleClusterReload(mainGridRowData.current, false);
        props.setCheckCompletedTrips(false);
        showCompletedCheckRef.current = false;
      }
    }
    catch (err) { console.log(err); }
  };

  const handleCheckCompleted2 = (IsChecked = true) => {
    try {
      if (IsChecked) {
        props.handleClusterReload(mainGridRowData.current, true);
        props.setCheckCompletedTrips(true);
        showCompletedCheckRef.current = true;
      }
      else {
        props.handleClusterReload(mainGridRowData.current, false);
        props.setCheckCompletedTrips(false);
        showCompletedCheckRef.current = false;
      }
    }
    catch (err) { console.log(err); }
  };

  const UpdateStatusesFromPersistStorage = () => {
    try {

      let _savedStatuses = PersistStorage.retrieve("_SelectedStatuses", false);
      const statusesOptions = [{ "name": "Undispatched", "id": "Undispatched" }, { "name": "In Progress", "id": "In Progress" },
      { "name": "Cancelled", "id": "Cancelled" }, { "name": "No-Show", "id": "No-Show" }, { "name": "Will Call", "id": "Will Call" },
      { "name": "Flagger", "id": "Flagger" }, { "name": "Hide Break/Depot Trips", "id": "Hide Break/Depot Trips" }];

      if (_savedStatuses != undefined && _savedStatuses != null && _savedStatuses != "") {
        SetStatusFilterMultiSelect(prevState => ({
          setSelectedValues: true,
          ...prevState,
          options: statusesOptions,
          selectedValues: _savedStatuses
        }));
      }
      else {
        SetStatusFilterMultiSelect({ ...StatusFilterMultiSelect, ...{ options: statusesOptions } });
      }
    } catch (error) { }
  };

  const UpdateGroupingFromPersistStorage = () => {
    try {
      let savedGrouping = PersistStorage.retrieve("_SelectedGrouping", false);
      const groupingOptions = [{ "name": "Grouped", "id": "1" }, { "name": "UnGrouped", "id": "2" }];
      if (savedGrouping != undefined && savedGrouping != null && savedGrouping != "") {
        SetGroupingMultiSelect(prevState => ({
          setSelectedValues: true,
          ...prevState,
          ...{ options: groupingOptions },
          selectedValues: savedGrouping
        }));
      }
      else {
        SetGroupingMultiSelect({ ...GroupingMultiSelect, ...{ options: groupingOptions } });
      }
    } catch (error) { }
  };

  const UpdateAttributesFromPersistStorage = () => {
    try {
      return; // Check later
      let _AffiliatesFilterMultiSelect = AffiliatesFilterMultiSelect;
      let savedAttributes = PersistStorage.retrieve("_SelectedAttributes", false);

      let optsAttr = AttributeData.filter(function (currentValue) {
        return _AffiliatesFilterMultiSelect.selectedValues.toString().indexOf(currentValue.iAttrATSPID.toString()) > -1 ? true : false;
      })
        .map(function (currentValue, index, origarray) {
          return { "name": currentValue.DisplayTitle, "id": currentValue.ID };
        });

      if (savedAttributes != undefined && savedAttributes != null && savedAttributes != true) {
        SetAttributesFilterMultiSelect(prevState => ({
          setSelectedValues: true,
          ...prevState,
          ...{ options: optsAttr },
          selectedValues: savedAttributes
        }));
      }
      else {
        SetAttributesFilterMultiSelect({ ...AttributesFilterMultiSelect, ...{ options: optsAttr } });
      }
    } catch (error) {

    }
  };

  function StatusFilterSelectCallback(selectedvals) {
    try {
      SetToolboxValues({ ...ToolboxValues, ...{ StatusList: selectedvals.join(",") } });
      let finalSelectedVals = [];
      if (selectedvals != undefined && selectedvals != null && selectedvals?.length > 0) {
        selectedvals.forEach(item => {
          let selection = { id: item, name: item }
          finalSelectedVals.push(selection);
        });
      }

      DispatchMainToolbarPersistStorage("Statuses", finalSelectedVals);
    }
    catch (err) { console.log(err); }
  }

  function GroupingSelectCallback(selectedvals) {
    try {
      let finalSelectedVals = [];
      SetToolboxValues({ ...ToolboxValues, ...{ Grouping: selectedvals.join(",") } });

      if (selectedvals != undefined && selectedvals != null && selectedvals?.length > 0) {
        selectedvals.forEach(item => {
          let selection = { id: item, name: item }
          finalSelectedVals.push(selection);
        });
      }

      DispatchMainToolbarPersistStorage("Grouping", finalSelectedVals);
    }
    catch (err) { console.log(err); }
  }

  function AttributesSelectCallback(selectedvals) {
    try {
      let all_attributes_value = (selectedvals.length);
      if (all_attributes_value === 0 || all_attributes_value === AttributesFilterMultiSelect.options.length) {
        SetToolboxValues({ ...ToolboxValues, ...{ AttrList: "" } });
        DispatchMainToolbarPersistStorage("AllAttributes", true);
      }
      else {
        SetToolboxValues({ ...ToolboxValues, ...{ AttrList: selectedvals.join(",") } });
        let finalSelectedVals = [];
        if (selectedvals != undefined && selectedvals != null && selectedvals?.length > 0) {
          selectedvals.forEach(item => {
            let selection = { id: item, name: item }
            finalSelectedVals.push(selection);
          });
          DispatchMainToolbarPersistStorage("Attributes", finalSelectedVals);
        }
        else {
          DispatchMainToolbarPersistStorage("Attributes", false);
        }
      }
    }
    catch (err) { console.log(err); }
  }

  function FSSelectCallback(selectedvals) {
    SetToolboxValues({ ...ToolboxValues, ...{ FSList: selectedvals.join(",") } });
    DispatchMainToolbarPersistStorage("FamilyAffiliatesFundingSource", selectedvals.join(","));
  }

  function FamilyGroupsSelectCallback(selectedfamily) {
    try {
      let savedFamily = PersistStorage.retrieve("_SelectedFamily", false);
      if (IsCalledFromPageReload.current == true || PageReload.current == true) {
        if (savedFamily != undefined && savedFamily != "") {
          selectedfamily = savedFamily;
        }
      }
      FilterAffiliatesBySelectedFamily(selectedfamily);

      DispatchMainToolbarPersistStorage("Family", selectedfamily);
      PageReload.current = false;
    }
    catch (err) { console.log(err); }
  }

  function SetSavedDate(IsCalledFromUseEffect = false, setCurrentDate = true) {
    try {
      
      let SavedData = PersistStorage.retrieve("DispatchToolBarDate", false);
      if (SavedData !== null && SavedData !== undefined && SavedData !== "" && (IsCalledFromPageReload.current === true || IsCalledFromUseEffect)) {
        if (SavedData.includes("Z")) {
          _startDate = new Date(SavedData.replace("Z", "") + " 00:00:00");
        }
        else {
          let year = SavedData.split("-")[0];
          let month = SavedData.split("-")[1];
          let day = SavedData.split("-")[2];
          _startDate = year + "-" + month + "-" + day;
          _startDate = new Date(year, (parseInt(month) - 1), day, 0, 0, 0);
        }

        let currentDate = new Date();
        let savedDate = moment(_startDate);
        currentDate = moment(currentDate);

        if (savedDate.isBefore(currentDate) && setCurrentDate) {
          _startDate = new Date();
          _startDate = String(_startDate.getFullYear().toString()) + "-" + String(_startDate.getMonth() + 1).padStart(2, "0") + "-" + String(_startDate.getDate()).padStart(2, "0")
          DispatchMainToolbarPersistStorage("ToolBarDate", _startDate);
          //PersistStorage.save("selectedDate", _startDate, 999, false);
        }
        else {
          _startDate = SavedData;
          //DispatchMainToolbarPersistStorage("ToolBarDate", _startDate);
          //PersistStorage.save("selectedDate", _startDate, 999, false);
        }

        // let newdate = format(_startDate, 'yyyy-MM-dd', { timeZone: 'UTC' });
        setselectedDate(_startDate);
        SetToolboxValues(prev => ({ ...prev, Date: _startDate }));
        //RequestedDateChange(_startDate);
        //SetToolboxValues({ ...ToolboxValues, ...{ Date: _startDate } });
      }
    } catch (error) { }
  }

  function RequestedDateChange(newdate) {
  //  debugger 
    // PersistStorage.save("DispatchToolBarDate", newdate, 360, false);
    newdate = formatDateString(newdate);
    DispatchMainToolbarPersistStorage("ToolBarDate", newdate);
    //SetToolboxValues(prev => ({ ...prev, Date: newdate }));
    

    const currentDate = moment().startOf('day');
    const selectedDate = moment(newdate).startOf('day');

    if (selectedDate.isBefore(currentDate)) {
      setSelectedBtns(completedQueueBtnRef.current.concat(globalBtnsRef.current));
      setMainGridType("Complete");
      props.setGridMainType("Complete");
      RequestedDateChangeRange(newdate);
    } else {
        setMainGridType("Dispatch");
        DispatchMainToolbarPersistStorage("ResetGrid", true);
        props.setGridMainType("Dispatch");

        //SetToolboxValues({ ...ToolboxValues, ...{ Date: newdate } });
    }
    SetToolboxValues(prev => ({ ...prev, Date: newdate }));
    if (mapBtnRef.current.textContent === "Hide Map") {
      mapBtnRef.current.click();
    }
    //SetToolboxValues({ ...ToolboxValues, ...{ Date: newdate } });
  }

  function formatDateString(dateStr) {
    try {
      const parts = dateStr.split("-");
      const year = parts[0];
      const month = parts[1].padStart(2, "0");
      const day = parts[2].padStart(2, "0");
      return `${year}-${month}-${day}`;  
    } catch (error) {
      return dateStr;
    }
    
    }

    const completedDateChangeDirectCall = useRef(false);
    function RequestedDateChangeRange(givenDate) {
      
      completedDateChangeDirectCall.current = true;
        setSelectedDateRange(givenDate);
        PersistStorage.save("DispatchToolBarDate", givenDate, 999, false);
        //completedDateChangeDirectCall.current = false;
    }


  function SetSavedTotalHours(savedHours) {
    try {

      if (savedHours != undefined && savedHours != null && savedHours != "") {
        let data = {
          placeholder: "",
          disable: false,
          id: "RequestTotalHoursOptions",
          className: "RequestTotalHoursOptions",
          hidePlaceholder: false,
          styles: { width: "70px", marginLeft: "3px", borderRadius:"0px" },
          initialValue: savedHours.toString(),
          maxValue: "24",
          minValue: "0"
        }
        updateValueExternally(savedHours.toString());
      }
    } catch (error) { }
  }

  function RequestTotalHours(newval) {
    setNumericValue(newval);
    SetToolboxValues({ ...ToolboxValues, ...{ TotalHours: parseInt(newval) } });
    DispatchMainToolbarPersistStorage("TotalHours", parseInt(newval));
  }

  const handleChange = (value) => {

    setNumericValue(value);
    SetToolboxValues({ ...ToolboxValues, ...{ TotalHours: parseInt(value) } });
    DispatchMainToolbarPersistStorage("TotalHours", parseInt(value));
  };

  const updateValueExternally = (value) => {
    setNumericValue(parseInt(value));
    SetToolboxValues({ ...ToolboxValues, ...{ TotalHours: parseInt(value) } });
  };

  function FilterAffiliatesBySelectedFamily(selectedvals, IsCalledFromUseEffect = false) {
    let optsAffiliates = [];
    let initialAffiliatesListSelected = [];
    let allowedaffiliates = loginData.UserAffiliateList.split(',');
    let allowedValidAffiliates = [];
    if (allowedaffiliates.length > 0) {
      try {
        for (var i = 0; i < AffiliateData.length; i++) {
          if (allowedaffiliates.indexOf(AffiliateData[i]["AffiliateID"].toString()) > -1) {
            allowedValidAffiliates.push(AffiliateData[i]["AffiliateID"].toString());
          }
        }
      }
      catch (o) { }
    }

    for (let i = 0; i < AffiliateData.length; i++) {
      const sortedAffiliateData = [...AffiliateData].sort((a, b) => {
        if (a?.bBroker === 1 && b?.bBroker !== 1) return -1;
        if (a?.bBroker !== 1 && b?.bBroker === 1) return 1;
        if (a?.AffiliateCompany < b?.AffiliateCompany) return -1;
        if (a?.AffiliateCompany > b?.AffiliateCompany) return 1;
        return 0;
      });
      if (allowedValidAffiliates.length > 0 && allowedValidAffiliates.indexOf(sortedAffiliateData[i]["AffiliateID"].toString()) < 0) {
        continue;
      }
      if (selectedvals.indexOf(sortedAffiliateData[i].DTSPID.toString()) > -1) {
        initialAffiliatesListSelected.push(sortedAffiliateData[i]["AffiliateID"].toString());
        optsAffiliates.push({ "name": sortedAffiliateData[i]["AffiliateCompany"], "id": sortedAffiliateData[i]["AffiliateID"] });
      }
    }
    // SetToolboxValues({...ToolboxValues,...{AffiliatesList:initialAffiliatesListSelected.join(",")}});
    // SetAffiliatesFilterMultiSelect({ ...AffiliatesFilterMultiSelect, ...{options: optsAffiliates}});
    let savedAffiliates = PersistStorage.retrieve("_SelectedFamilyAffiliates", false);
    if ((IsCalledFromPageReload.current == true || PageReload.current == true || IsCalledFromUseEffect == true) && savedAffiliates != undefined && savedAffiliates != null && savedAffiliates != "") {
      initialAffiliatesListSelected = savedAffiliates;
      SetAffiliatesFilterMultiSelect({ ...AffiliatesFilterMultiSelect, ...{ options: optsAffiliates, selectedValues: savedAffiliates.split() } });
      IsCalledFromPageReload.current = false;
    }
    else {
      SetAffiliatesFilterMultiSelect({ ...AffiliatesFilterMultiSelect, ...{ options: optsAffiliates, selectedValues: optsAffiliates[0].id.toString().split() } });
    }
    if (initialAffiliatesListSelected?.split != undefined) {
      SetToolboxValues({ ...ToolboxValues, ...{ AffiliatesList: initialAffiliatesListSelected.split().join(",") } });
    }
    else {
      SetToolboxValues({ ...ToolboxValues, ...{ AffiliatesList: initialAffiliatesListSelected.join(",") } });
    }

    FilterFundingSourcesBySelectedAffiliates(initialAffiliatesListSelected);
    FilterAttributesBySelectedAffiliates(initialAffiliatesListSelected);
  }

  function FilterFundingSourcesBySelectedAffiliates(selectedAffiliates) {
    let optsFS = [];
    for (const key in FundingSourceData) {
      if (FundingSourceData.hasOwnProperty(key) && selectedAffiliates.indexOf(key.toString()) > -1) {
        const value = FundingSourceData[key];
        try {
          const FundingSourceDataJSON = JSON.parse(value);
          for (var i = 0; i < FundingSourceDataJSON.length; i++) {
            optsFS.push({ "name": FundingSourceDataJSON[i]["AccountID"] + " (" + FundingSourceDataJSON[i].AffiliateAbbrevation + ")", "id": (FundingSourceDataJSON[i]["FID"] + "-" + FundingSourceDataJSON[i]["iFSATSPID"]) });
          }
        } catch (error) {
        }
      }
    }
    SetFundingSourceFilterMultiSelect({ ...FundingSourceFilterMultiSelect, ...{ options: optsFS } });
  }

  function FilterAttributesBySelectedAffiliates(selectedAffiliates) {
    let attrSelection = AttributeData ? AttributeData.filter((item,index)=> {return parseInt(item.iAttrATSPID) === parseInt(selectedAffiliates) && parseInt(item.iAttrType) !== 10 }) : [];
    let optsAttr = attrSelection.map(function (currentValue, index, origarray) {
      return { "name": currentValue.DisplayTitle, "id": currentValue.ID };
    });
    SetAttributesFilterMultiSelect({ ...AttributesFilterMultiSelect, ...{ options: optsAttr } });
    let all_attributes_value = AttributesFilterMultiSelect.selectedValues.length;
    if (all_attributes_value === 0 || all_attributes_value === AttributesFilterMultiSelect.options.length) {
      DispatchMainToolbarPersistStorage("AllAttributes", true);
    }
    else {
      let finalSelectedVals = [];
      if (optsAttr != undefined && optsAttr != null && optsAttr?.length > 0) {
        optsAttr.forEach(item => {
          let selection = { id: item, name: item }
          finalSelectedVals.push(selection);
        });
        DispatchMainToolbarPersistStorage("Attributes", finalSelectedVals);
      }
      else {
        DispatchMainToolbarPersistStorage("Attributes", false);
      }
    }
  }

  function FilterOptionsAccordingToSelectedAffiliates(selectedAffiliatesInIntForm) {
    try{
      let savedAffiliates = PersistStorage.retrieve("_SelectedFamilyAffiliates", false);

      if (IsCalledFromPageReload.current === true && savedAffiliates !== null && savedAffiliates !== undefined && savedAffiliates !== "") {
        let savedFamily = PersistStorage.retrieve("_SelectedFamily", false);
        if (savedFamily != undefined && savedFamily != null && savedFamily != "") {
          selectedAffiliatesInIntForm = savedAffiliates.split();
        }
      }
      SetToolboxValues({ ...ToolboxValues, ...{ AffiliatesList: selectedAffiliatesInIntForm.join(",") } });

      let selectedAffiliates = selectedAffiliatesInIntForm.map(function (currentValue) { return currentValue.toString(); });
      // SetToolboxValues({...ToolboxValues,...{AffiliatesList:selectedAffiliates.join(",")}});
      // mapBtnRef.current.textContent = "Map";
      // mapBtnRef.current.title = "Map View";
      props.selectedTripInfoToRefreshGrid.current = null
      props.DropDownRouteValue.current = null
      props.setDetailDataFunc([])
      // props.handleMapHeight(100);
      // props.handleMapMode(false);
      mainGridRowData.current = null;
      handleMapView('aff');

      FilterFundingSourcesBySelectedAffiliates(selectedAffiliates);
      FilterAttributesBySelectedAffiliates(selectedAffiliates);

      DispatchMainToolbarPersistStorage("FamilyAffiliates", selectedAffiliates.join(","));
      DispatchMainToolbarPersistStorage("FamilyAffiliatesFundingSource", "");
    } catch(err){console.log(err);}
  }

  const DispatchMainToolbarPersistStorage = (key, value) => {
    try {
      if (key == undefined || key == "") { return; }

      if (key == "FamilyAffiliates" && value != undefined) {
        PersistStorage.save("_SelectedFamilyAffiliates", value, 360, false);
      }
      else if (key == "Family" && value != undefined) {
        PersistStorage.save("_SelectedFamily", value, 360, false);
      }
      else if (key == "Statuses" && value != undefined) {
        PersistStorage.save("_SelectedStatuses", value, 360, false);
      }
      else if (key == "TotalHours" && value != undefined) {
        PersistStorage.save("_SelectedTotalHours", value, 360, false);
      }
      else if (key == "ToolBarDate" && value != undefined) {
        PersistStorage.save("DispatchToolBarDate", value, 360, false);
      }
      else if (key == "FamilyAffiliatesFundingSource" && value != undefined) {
        PersistStorage.save("_SelectedFamilyAffiliates_FS", value, 360, false);
      }
      else if (key == "AllAttributes" && value != undefined) {
        PersistStorage.save("_SelectedAsAllAttributes", value, 360, false);
      }
      else if (key == "Attributes" && value != undefined) {
        PersistStorage.save("_SelectedAttributes", value, 360, false);
      }
      else if (key == "Grouping" && value != undefined) {
        PersistStorage.save("_SelectedGrouping", value, 360, false);
      }
      else if (key == "DriverActionsDialog" && value != undefined) {
        PersistStorage.save("IsDriverActionsDialogOpened", value, 5, false);
      }
      else if (key == "TripDetailsDialog" && value != undefined) {
        PersistStorage.save("IsTripDetailsDialogOpened", value, 10, false);
      }
      else if (key == "ResetGrid" && value != undefined) {
        PersistStorage.save("ResetGrid", value, 360, false);
      }

    } catch (error) { console.log(error) }
  };
  async function reloadIntervalHandler(requestBody, newTab, tabIntervalId) {
    if (newTab.closed) {
      console.warn("New tab was closed, stopping interval.");
      clearInterval(tabIntervalId);
      return;
    }
  
    let dropdown_value = localStorage.getItem("dropdown_value") || "-1";
    const selected_indices = localStorage.getItem("selected_indices") || "-1";
    const selected_zone = localStorage.getItem("Selected_zone") || "-1";
    if (dropdown_value === "Choose Sort by") {
      dropdown_value = "-1";
    }
    const updatedRequestBody = {
      ...requestBody,
      dropdown_value: dropdown_value,
      selected_indices: selected_indices,
      selected_zone: selected_zone,
    };
  
    let reloadResponse = await APICom.fetchData(
      "GenericReportingURL",
      "RouteActivityReport/getRouteActivityPlot",
      "post",
      { "Content-Type": "application/json" },
      JSON.stringify(updatedRequestBody),
      null
    );
  
    if (reloadResponse.data && reloadResponse.data !== "No Data Found") {
      const iframe = newTab.document.getElementById("routeIframe");
      iframe.srcdoc = reloadResponse.data;
    } else {
      console.warn("No data found on reload");
    }
  }
  window.reloadIntervalHandler = reloadIntervalHandler;
  async function openHtmlRouteActivity() {
    try {
      setModalHeaderText("Daily OTP Plot");
      setModalBodyHTML(
        <b>
          {"We are plotting your Route Plot. When the report is ready, it will open automatically in a new tab. Please wait.... "}
        </b>
      );
      setModalFooterHTML(
        <Button
          variant="secondary"
          className="border-0"
          onClick={() => setShowDynamicModal(false)}
        >
          OK
        </Button>
      );
      setShowDynamicModal(true);
  
      let date = PersistStorage.retrieve("selectedDate", true) || ToolboxValues?.Date;
      let FS = JSON.parse(sessionStorage.getItem("_SelectedFamilyAffiliates_FS")) || "";
      let updatedFS = "";
      if (FS){
        const splitData = FS.data.split(',');
        const extractedData = splitData.map(item => item.split('-')[0]);
        updatedFS = extractedData.join(',');
      }
      const requestBody = {
        dtSelectedDate: date,
        vAffiliateID: affiliateRef.current.toString(),
        reportType: "1",
        dropdown_value: "-1",
        selected_indices: "-1",
        selected_zone: "-1",
        FS: updatedFS,
      };
  
      let response = await APICom.fetchData(
        "GenericReportingURL",
        "RouteActivityReport/getRouteActivityPlot",
        "post",
        { "Content-Type": "application/json" },
        JSON.stringify(requestBody),
        null
      );
  
      if (response.data && response.data.error) {
        setShowDynamicModal(false);
        setModalHeaderText("Warning");
        setModalBodyHTML(<b>{"No data exists for the Daily OTP Plot."}</b>);
        setModalFooterHTML(
          <Button
            variant="secondary"
            className="border-0"
            onClick={() => setShowDynamicModal(false)}
          >
            OK
          </Button>
        );
        setShowDynamicModal(true);
      } else if (response.data && response.data !== "No Data Found") {
        setShowDynamicModal(false);
  
        const newTab = window.open("", "_blank");
  
        if (newTab) {
          const encodedScript = `
            const requestBody = ${JSON.stringify(requestBody)};
            const tabIntervalId = null;

            async function reloadIntervalHandlerWrapper() {
              const refreshBtn = document.getElementById("refreshBtn");
              refreshBtn.disabled = true;
              refreshBtn.textContent = "Refreshing...";
              try {
                if (window.opener && typeof window.opener.reloadIntervalHandler === "function") {
                  await window.opener.reloadIntervalHandler(
                    requestBody,
                    window,
                    window.tabIntervalId || null
                  );
                } else {
                  console.warn("Parent reloadIntervalHandler not available");
                }
              } catch (error) {
                console.error("Error during manual refresh:", error);
              } finally {
                refreshBtn.disabled = false;
                refreshBtn.textContent = "Refresh OTP Plot";
              }
            }

            document.getElementById("refreshBtn").addEventListener("click", reloadIntervalHandlerWrapper);
            document.getElementById("closeBtn").addEventListener("click", function () {
              window.close();
            });
          `;
          newTab.document.write(`
            <!DOCTYPE html>
            <html lang="en">
            <head>
              <meta charset="UTF-8">
              <meta name="viewport" content="width=device-width, initial-scale=1.0">
              <title>Daily OTP Plot</title>
              <style>
                body { 
                  margin: 0; 
                  display: flex; 
                  flex-direction: column; 
                  height: 100vh; 
                  background: white; 
                  overflow: hidden; 
                }
                .header {
                  background: white;
                  padding: 10px;
                  text-align: right;
                  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
                  z-index: 1000;
                  position: relative;
                }
                .content {
                  flex-grow: 1;
                  display: flex;
                }
                iframe {
                  width: 100%;
                  height: 100%;
                  border: none;
                  display: block;
                }
                .close-btn, .refresh-btn {
                  padding: 8px 16px;
                  color: white;
                  border: none;
                  cursor: pointer;
                  font-size: 14px;
                  border-radius: 4px;
                  transition: background 0.3s ease-in-out;
                  margin-left: 10px;
                }
                .refresh-btn {
                  background: #007bff;12
                }
                .refresh-btn:hover {
                  background: #0056b3;
                }
                .close-btn {
                  background: red;
                }
                .close-btn:hover {
                  background: darkred;
                }
              </style>
            </head>
            <body>
              <div class="header">
                <button class="refresh-btn" id="refreshBtn">Refresh OTP Plot</button>
                <button class="close-btn" id="closeBtn">Close</button>
              </div>
              <div class="content">
                <iframe id="routeIframe"></iframe>
              </div>
              <script>
                ${encodedScript}
              </script>
            </body>
            </html>
          `);

          newTab.document.close();
          const today = new Date();
          const selectedDate = new Date(date);

          if (today.toDateString() === selectedDate.toDateString()) {
            // Only start the interval if the dates match
            const tabIntervalId = setInterval(() => {
              reloadIntervalHandler(requestBody, newTab, tabIntervalId);
            }, 60000);


            newTab.onbeforeunload = () => {
              clearInterval(tabIntervalId);
            };
          }
          setTimeout(() => {
            const iframe = newTab.document.getElementById("routeIframe");
            iframe.srcdoc = response.data;
          }, 800);
        } else {
          console.error("Failed to open a new tab. Check pop-up blockers.");
        }
      } else {
        setShowDynamicModal(false);
        setModalHeaderText("Warning");
        setModalBodyHTML(<b>{"No data exists for the Daily OTP Plot."}</b>);
        setModalFooterHTML(
          <Button
            variant="secondary"
            className="border-0"
            onClick={() => setShowDynamicModal(false)}
          >
            OK
          </Button>
        );
        setShowDynamicModal(true);
      }
    } catch (error) {
      console.error("Error opening HTML in a new tab:", error);
    }
  }
  async function openHtmlTripsDashboard() {
    const affiliateId = affiliateRef.current.toString();
    const dtSelectedDate = PersistStorage.retrieve("selectedDate", true) || ToolboxValues?.Date;
    const affiliate = AffiliateData.find(item => item.AffiliateID === +affiliateId);
    const affiliateName = affiliate ? affiliate.AffiliateCompany : null;

    const requestBody = {
      affiliate_id: affiliateId,
      dtSelectedDate: dtSelectedDate,
      affiliate_Name: affiliateName,
      tab: "4"
    };

    const response = await APICom.fetchData(
      "GenericReportingURL",
      "trips_dashboard/getTripsDasboard",
      "post",
      { "Content-Type": "application/json" },
      JSON.stringify(requestBody),
      null
    );

    const baseUrl = response.data.url.split('#')[0];
    const finalUrl = baseUrl + '#fullscreen';

    const htmlContent = `
      <!DOCTYPE html>
      <html lang="en">
      <head>
        <meta charset="UTF-8">
        <title>Trips Dashboard</title>
        <style>
          html, body {
            margin: 0;
            height: 100%;
            width: 100%;
            overflow: hidden;
          }
          .header {
            padding: 10px;
            background: white;
            text-align: right;
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          }
          .btn {
            background: #007bff;
            color: white;
            border: none;
            padding: 8px 16px;
            cursor: pointer;
            border-radius: 4px;
            margin-left: 8px;
          }
          .content {
            height: calc(100% - 50px);
            position: relative;
          }
          iframe {
            width: 100%;
            height: 100%;
            border: none;
          }
          .slide-frame {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: none;
          }
        </style>
      </head>
      <body>
        <div class="header">
          <button class="btn" onclick="goFullscreen()" id="fullscreenBtn">Go Fullscreen</button>
          <button class="btn" onclick="enableSlideMode()" id="SlideBtn" >Slide View</button>
          <button class="btn" onclick="disableSlideMode()" id="exitSlideBtn" style="display:none;">Exit Slide</button>
          <button class="btn" onclick="window.close()">Close</button>
        </div>

        <div class="content">
          <iframe id="mainIframe" src="${finalUrl}" allowfullscreen></iframe>
          <div id="slideContainer"></div>
        </div>

        <script>
          let slideUrls = [];
          let slideIframes = [];
          let rotationInterval = null;
          let currentIndex = 0;

          function goFullscreen() {
            const btn = document.getElementById("fullscreenBtn");
            const el = document.documentElement;

            if (!btn) return;

            if (btn.textContent === "Go Fullscreen") {
              // Enter fullscreen
              if (el.requestFullscreen) el.requestFullscreen();
              else if (el.webkitRequestFullscreen) el.webkitRequestFullscreen();
              else if (el.mozRequestFullScreen) el.mozRequestFullScreen();
              else if (el.msRequestFullscreen) el.msRequestFullscreen();

              btn.textContent = "Exit Fullscreen";
            } else {
              // Exit fullscreen
              if (document.exitFullscreen) document.exitFullscreen();
              else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
              else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
              else if (document.msExitFullscreen) document.msExitFullscreen();

              btn.textContent = "Go Fullscreen";
            }
          }
          function enableSlideMode() {
            if (!slideUrls.length) {
              alert("Slide URLs not loaded yet.");
              return;
            }
            goFullscreen();
            document.getElementById('mainIframe').style.display = 'none';
            document.getElementById('exitSlideBtn').style.display = 'inline-block';
            document.getElementById('SlideBtn').style.display = 'none';

            const container = document.getElementById("slideContainer");
            container.innerHTML = "";
            slideIframes = [];

            slideUrls.forEach((url, index) => {
              const iframe = document.createElement("iframe");
              iframe.src = url;
              iframe.className = "slide-frame";
              iframe.style.display = index === 0 ? "block" : "none";
              container.appendChild(iframe);
              slideIframes.push(iframe);
            });

            currentIndex = 1;
            rotationInterval = setInterval(() => {
              slideIframes.forEach((iframe, i) => {
                iframe.style.display = i === currentIndex ? "block" : "none";
              });
              currentIndex = (currentIndex + 1) % slideIframes.length;
            }, 30000);
          }

          function disableSlideMode() {
            clearInterval(rotationInterval);
            goFullscreen();
            document.getElementById("slideContainer").innerHTML = "";
            document.getElementById("mainIframe").style.display = "block";
            document.getElementById('SlideBtn').style.display = 'inline-block';
            document.getElementById("exitSlideBtn").style.display = "none";
          }

          document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') disableSlideMode();
          });

          window.addEventListener('message', (event) => {
            if (event.data.type === 'slideUrls') {
              slideUrls = event.data.urls || [];
            }
          });
        </script>
      </body>
      </html>
    `;

    const blob = new Blob([htmlContent], { type: 'text/html' });
    const blobUrl = URL.createObjectURL(blob);
    const newWindow = window.open(blobUrl, '_blank');

    const dashboardTabs = ["4", "12", "5", "13", "6", "14"];
    const urls = await Promise.all(
      dashboardTabs.map(async (tab) => {
        const tabRequest = {
          affiliate_id: affiliateId,
          dtSelectedDate: dtSelectedDate,
          affiliate_Name: affiliateName,
          tab: tab,
        };

        try {
          const res = await APICom.fetchData(
            "GenericReportingURL",
            "trips_dashboard/getTripsDasboard",
            "post",
            { "Content-Type": "application/json" },
            JSON.stringify(tabRequest),
            null
          );
          return res.data.url;
        } catch (error) {
          console.error("Error loading tab", tab, error);
          return "about:blank";
        }
      })
    );
    const sendUrls = () => newWindow.postMessage({ type: 'slideUrls', urls }, "*");
    newWindow.onload = sendUrls;
  }
  async function openHtmlFixedBusDashboard() {
    const affiliateId = affiliateRef.current.toString();
    const dtSelectedDate = PersistStorage.retrieve("selectedDate", true) || ToolboxValues?.Date;
    const affiliate = AffiliateData.find(item => item.AffiliateID === +affiliateId);
    const affiliateName = affiliate ? affiliate.AffiliateCompany : null;
    const requestBody = {
      region: "gta",
      tab: "7",
      pickup_start_date: dtSelectedDate,
      pickup_end_date: "",
      route: "",
      station: "",
      vehicle_number: "",
      fixed_bus_source: ""
    };

    try {
      const response = await APICom.fetchData(
        "GenericReportingURL",
        "trips_dashboard/getFixedBusDashboard",
        "post",
        { "Content-Type": "application/json" },
        JSON.stringify(requestBody),
        null
      );

      const iframeUrl = response.data?.url;

      if (!iframeUrl) {
        alert("Dashboard URL not returned.");
        return;
      }

      const htmlContent = `
        <!DOCTYPE html>
        <html lang="en">
        <head>
          <meta charset="UTF-8">
          <title>Fixed Bus Dashboard</title>
          <style>
            html, body {
              margin: 0;
              height: 100%;
              width: 100%;
              overflow: hidden;
            }
            .header {
              padding: 10px;
              background: white;
              text-align: right;
              box-shadow: 0 2px 4px rgba(0,0,0,0.1);
            }
            .btn {
              background: #007bff;
              color: white;
              border: none;
              padding: 8px 16px;
              cursor: pointer;
              border-radius: 4px;
              margin-left: 8px;
            }
            .content {
              height: calc(100% - 50px);
              position: relative;
            }
            iframe {
              width: 100%;
              height: 100%;
              border: none;
            }
          </style>
        </head>
        <body>
          <div class="header">
            <button class="btn" onclick="goFullscreen()" id="fullscreenBtn">Go Fullscreen</button>
            <button class="btn" onclick="window.close()">Close</button>
          </div>
          <div class="content">
            <iframe src="${iframeUrl}" allowfullscreen></iframe>
          </div>

          <script>
            function goFullscreen() {
              const btn = document.getElementById("fullscreenBtn");
              const el = document.documentElement;
              if (btn.textContent === "Go Fullscreen") {
                (el.requestFullscreen || el.webkitRequestFullscreen || el.mozRequestFullScreen || el.msRequestFullscreen).call(el);
                btn.textContent = "Exit Fullscreen";
              } else {
                (document.exitFullscreen || document.webkitExitFullscreen || document.mozCancelFullScreen || document.msExitFullscreen).call(document);
                btn.textContent = "Go Fullscreen";
              }
            }
          </script>
        </body>
        </html>
      `;

      const blob = new Blob([htmlContent], { type: "text/html" });
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, "_blank");
    } catch (error) {
      console.error("Fixed Bus Dashboard API failed:", error);
      alert("Unable to load fixed bus dashboard.");
    }
  }

  async function openParatransitDashboard() {
    try {
      const UserName = loginData.vUserName;
      const Password = loginData.vPassword;
      const webmrms = true;

      const RouteMapDashboardUrl = GlobalASCSData.find(dict => dict.SubTitle === "RouteMapDashboardUrl").value ;                         
      if (RouteMapDashboardUrl) {
        const separator = RouteMapDashboardUrl.includes("?") ? "&" : "?"; 
        const dashboardUrl = `${RouteMapDashboardUrl}${separator}affiliateid=${encodeURIComponent(UserAffiliateList)}&username=${UserName}&password=${Password}&webmrms=${webmrms}&typeId=0`;

        var urlTemp = window.location.href.toLowerCase();
        var pageNameLocation = urlTemp.indexOf("newrequest");

        if (pageNameLocation > -1) {
          window.open(dashboardUrl, '_blank');
          return false;
        }

        window.open(dashboardUrl, '_blank');

      } else {
        console.error("RouteMapDashboardUrl not found.");
      }

    } catch (error) {
      console.error("An error occurred while opening the RouteMapDashboardUrl:", error);
    }
  }


  async function openAIChat() {
    try {
      const affiliateId = affiliateRef.current.toString(); 

      const AiReportURL = (GlobalASCSData.find(dict => dict.SubTitle === "AiReportURL") 
                            ? GlobalASCSData.find(dict => dict.SubTitle === "AiReportURL").value 
                            : "https://aireports.itcurves.us/chat");
      if (AiReportURL) {
        const separator = AiReportURL.includes("?") ? "&" : "?";
        const chatUrl = `${AiReportURL}${separator}affiliateid=${encodeURIComponent(UserAffiliateList)}`;

        const htmlContent = `
          <!DOCTYPE html>
          <html lang="en">
          <head>
            <meta charset="UTF-8">
            <title>Chat Interface</title>
            <style>
              html, body {
                margin: 0;
                padding: 0;
                height: 100%;
                width: 100%;
                overflow: hidden;
              }
              iframe {
                width: 100%;
                height: 100%;
                border: none;
              }
            </style>
          </head>
          <body>
            <iframe src="${chatUrl}" allowfullscreen></iframe>
          </body>
          </html>
        `;

        const blob = new Blob([htmlContent], { type: 'text/html' });
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl, '_blank');
      } else {
        console.error("AiReportURL not found.");
      }
    } catch (error) {
      console.error("An error occurred while opening the AI chat:", error);
    }
  }


  function navigateToPage() {
    window.open(`/ManifestSetting?id=${affiliateRef.current.toString()}`, '_blank');
  };

  async function ShowMultiSchData(refID) {
    try {
      const response = await APICom.fetchData("AspDotNetCoreURL", `TripHistoryReports/GetMultiScheduleReport?refid=${refID}`, "get", {}, {});

      if (response && response.error.length === 0) {
        if (response.data && Array.isArray(response.data) && response.data.length > 0) {
          //Data generated
          await GenerateMultiSchReport(response.data);
        }
        else if (response.data && response.data.length === 0) {
          setModalHeaderText("Multi-Schedule Report Alert");
          setModalBodyHTML(<p>{"There is report data for this trip, please contact the administrator."}</p>);
          setModalFooterHTML(
            <Button variant="dark" className="mx-1 border-0" onClick={() => setShowDynamicModal(false)}>
              {"OK"}
            </Button>
          );
          setShowDynamicModal(true);
        }
      }
      else {
        setModalHeaderText("Multi-Schedule Report Alert");
        setModalBodyHTML(<p>{(response.error.length > 0 ? response.error : "There was an issue with the API, please contact the administrator.")}</p>);
        setModalFooterHTML(
          <Button variant="dark" className="mx-1 border-0" onClick={() => setShowDynamicModal(false)}>
            {"OK"}
          </Button>
        );
        setShowDynamicModal(true);
      }

    }
    catch (err) { console.log(err); }
  }

  async function GenerateMultiSchReport(dataArr) {
    try {
      // let JSONData = JSON.stringify(dataArr);
      let myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/json');
      let headersObj = headersToObject(myHeaders);
      let reportingURL = mainstore.getState().configuration.REACT_APP_MRMS_REPORTING_API + "ShowMultiScheduleReport";
      let ReportResponse = await APICom.fetchData("full", reportingURL, "post", headersObj, dataArr, null, false, {}, 'blob');
      if (ReportResponse && ReportResponse.error.length === 0) {
        const blob = new Blob([ReportResponse.data], { type: "application/pdf" });
        const pdfUrl = URL.createObjectURL(blob);

        window.open(pdfUrl, '_MultiSchReportPDF');
        URL.revokeObjectURL(pdfUrl);
      }
      else {
        setModalHeaderText("Multi-Schedule Report Alert");
        setModalBodyHTML((ReportResponse.error.length > 0 ? ReportResponse.error : "There was an issue with the API, please contact the administrator."));
        setModalFooterHTML(
          <Button variant="dark" className="mx-1 border-0" onClick={() => setShowDynamicModal(false)}>
            {"OK"}
          </Button>
        );
        setShowDynamicModal(true);
      }
    }
    catch (err) { console.log(err); }
  }

  function headersToObject(headers) {
    try {
      let result = {};
      for (let [key, value] of headers.entries()) {
        result[key] = value;
      }
      return result;
    }
    catch (err) { console.log(err); return []; }
  };

  const [openVoiceAssistant, setOpenVoiceAssistant] = useState(false);
  const OpenVoiceAssistance = () => {
    setOpenVoiceAssistant(prev => !prev); // toggle true/false
    if(openVoiceAssistant){
      setModalHeaderText("Upcoming Feature");
      setModalBodyHTML(<MapVoice onAction={handleVoiceAction}></MapVoice>);
      setModalFooterHTML(
          <Button variant="dark" className="mx-1 border-0" onClick={()=>
            {
              setShowDynamicModal(false);
              setOpenVoiceAssistant(false);
            }
          }>
          {"OK"}
          </Button>
      );
      setShowDynamicModal(true);
    }
    else{
      //setShowDynamicModal(false);
    }
   
  };

  const handleVoiceAction = (action, data) => {
    if (action === "OpenMap") {
      if(mapBtnRef.current.textContent === "Map"){
        handleMapView();
      }
    } 
    else if (action === "CloseMap") 
    {
      if(mapBtnRef.current.textContent === "Hide Map")
      {
        handleMapView();
      }
    }
    else if (action === "PlotZonesOnMap" && mapBtnRef.current.textContent === "Hide Map")
    {
      props.OnMapActions("PlotZonesOnMap"); // Calls the Dispatch.js or whichever componenet is using DispatchMainToolBar
    }
    else if(action === "UnPlotZonesFromMap" && mapBtnRef.current.textContent === "Hide Map")
    {
      props.OnMapActions("UnPlotZonesFromMap");
    }
    else if(action === "ShowTripsByStatus"){
      props.OnMapActions("ShowTripsByStatus", data);
    }
    else if(action == "ClearFilters"){
      props.OnMapActions("ClearFilters", data);
    }
  };


  return (
    <>
      <Navbar ref={navBarRef} className="bg-body-tertiary justify-content-between DispatchToolbarNav pe-2 callAgentSummaryScroller" style={{ height: "50px" }}>
        <Form ref={formRef} className={`form-inline`}>
          <InputGroup>
            {mainGridType !== 'Standing' && mainGridType !== 'Complete' ? 
              <>
                <MultiSelectDropdown options={StatusFilterMultiSelect} style={dropdownpadding} SelectionChangeCallback={StatusFilterSelectCallback} IsPageReloadCall={IsPageReloadCalled}/>
                <MultiSelectDropdown options={GroupingMultiSelect} style={dropdownpadding} SelectionChangeCallback={GroupingSelectCallback} IsPageReloadCall={IsPageReloadCalled}/> 
              </> 
            :""}
            <MultiSelectDropdown options={AttributesFilterMultiSelect} style={dropdownpadding} SelectionChangeCallback={AttributesSelectCallback} IsPageReloadCall={IsPageReloadCalled}/>  
            <MultiSelectDropdown options={FamilyGroupsSingleSelect} singleselect="true" SingleSelectClass={FamilyGroupsSingleSelect.SingleSelectClass} style={dropdownpadding} SelectionChangeCallback={FamilyGroupsSelectCallback} IsPageReloadCall={IsPageReloadCalled}/>  
            <MultiSelectDropdown options={AffiliatesFilterMultiSelect} singleselect="true" SingleSelectClass={AffiliatesFilterMultiSelect.SingleSelectClass} style={dropdownpadding} SelectionChangeCallback={FilterOptionsAccordingToSelectedAffiliates} IsPageReloadCall={IsPageReloadCalled}/>  
            <MultiSelectDropdown options={FundingSourceFilterMultiSelect} style={dropdownpadding} SelectionChangeCallback={FSSelectCallback} IsPageReloadCall={IsPageReloadCalled}/>
            {mainGridType !== 'Standing' && mainGridType !== 'Complete' ? 
              <>
                <DateTimePicker options={RequestDateOptions} SelectionChangeCallback={RequestedDateChange} IsPageReloadCall={IsPageReloadCalled} SelectedDate={selectedDate}></DateTimePicker>
                {/* <NumericControl options={RequestTotalHoursOptions} SelectionChangeCallback={RequestTotalHours} SetValueInControl={numericValue} IsPageReloadCall={IsPageReloadCalled}></NumericControl> */}
                <NumericControl value={numericValue} onChange={handleChange} />
              </>
            : ""}
            {mainGridType === 'Complete'?
              <>
                <DateTimePicker options={RequestDateOptionsRange} SelectionChangeCallback={RequestedDateChangeRange} IsPageReloadCall={IsPageReloadCalled} SelectedDate={selectedDateRange}></DateTimePicker>
              </>
            : ""}
            <span className='ms-1 bg-transparent user-select-none'></span>
            {/* <Button variant='outline-dark' id={props.options.GridName+'_mapViewBtn'} type='button' title='Map View' className='rounded mx-1 px-2 z-0' onClick={handleMapView} ref={mapBtnRef}>Map</Button> */}
            {showRouteDropDown && mainGridType !== 'Standing' && mainGridType !== 'Complete'?
              <div title='Select Route' className='text-nowrap SelectRouteDiv' onClick={handleRouteDropDownClick} style={{zIndex: "250"}}>
                  <MultiSelectDropdown  selectedValues = {SelectedRouteOrCluster} options={clusterFilterMultiSelect} 
                  showCheckbox={false} className="mx-1 ms-2" SelectionChangeCallback={RouteSelectCallback} IsPageReloadCall={IsPageReloadCalled}/>
              </div>

              : ""}
            {/* {showRouteDropDown && (mainGridType === 'Dispatch') ?
              <div className='p-1 border mx-1' style={{ minWidth: "135px", marginLeft: "3px", alignContent: "center"}}>
                <p className='m-0 d-inline-flex fw-bold user-select-none' style={{ fontSize: "small" }}>Show Completed</p>
                <input type={"checkbox"} style={{ cursor: "pointer" }} title="Show Completed Trips" className='mx-1 d-inline-flex' onClick={handleCheckCompleted} />
              </div>
              : ""} */}
            <span className="user-select-none d-flex my-auto small text-center" title={mainGridType + " Queue"} style={{ height: "40px"}}>
              <select className='text-center p-1 w-100 ms-1' style={{ border:"0.1px solid lightgray", minWidth: "110px", maxWidth: "140px", borderRadius:"0px"}} value={mainGridType}
                onChange={(e) => {
                  if (e.target.value === 'Standing') {
                    setSelectedBtns(standingOrderBtnRef.current.concat(globalBtnsRef.current));
                  }
                  else if(e.target.value === 'Complete')
                  {
                    setSelectedBtns(completedQueueBtnRef.current.concat(globalBtnsRef.current));
                    completedDateChangeDirectCall.current = true;
                    
                    let SavedDate = PersistStorage.retrieve("DispatchToolBarDate", false);
                    if (SavedDate) {
                      if (SavedDate.includes("Z")) {
                        _startDate = new Date(SavedDate.replace("Z", "") + " 00:00:00");
                      } else if (/^\d{4}-\d{2}-\d{2}$/.test(SavedDate)) {
                        _startDate = SavedDate; // use as-is
                      } else {
                        let [year, month, day] = SavedDate.split("-");
                        _startDate = new Date(year, parseInt(month) - 1, day, 0, 0, 0);
                      }
                    }
                    setSelectedDateRange(SavedDate);
                  }
                  else
                  {
                    let tripType = (transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2);
                    let selectedRef = (tripType ? microtransitBtnsRef.current.concat(globalBtnsRef.current) : paratransitBtnsRef.current.concat(globalBtnsRef.current));
                    setSelectedBtns(selectedRef);
                    SetSavedDate(true, false);
                    completedDateChangeDirectCall.current = false;
                  }
                  setMainGridType(e.target.value);
                  props.setGridMainType(e.target.value);
                  if (mapBtnRef.current.textContent === "Hide Map") {
                    mapBtnRef.current.click();
                  }
                }}
                onClick={(e) => { }}
              >
                <option value={"Dispatch"}>{"Dispatch Queue"}</option>
                <option value={"Standing"}>{"Standing Queue"}</option>
                <option value={"Complete"}>{"Complete Queue"}</option>
              </select>
            </span>
            <Button variant='outline-dark' id={props.options.GridName + '_mapViewBtn'} style={{border:"0.1px solid lightgray"}} type='button' title='Map View' className='mx-1 px-2 z-0' onClick={handleMapView} ref={mapBtnRef}>Map</Button>
            {/* <Button
             variant='outline-dark' id={props.options.GridName + '_mapViewBtn'} style={{border:"0.1px solid lightgray"}} type='button' title='Enable Map voice Assistant' className='mx-1 px-2 z-0' onClick={OpenVoiceAssistance}>
                <Icon 
                        icon={micIcon} 
                        width="16" 
                        height="16" 
                        style={{color: 'black'}}
                />
            </Button> */}
            {/* <Button variant='outline-dark' id={props.options.GridName + '_mapViewBtn'} style={{border:"0.1px solid lightgray"}} type='button' title='Map View' className='mx-1 px-2 z-0' onClick={handleMapView} ref={mapBtnRef}>Map</Button> */}
            {/* <Button variant='light' onClick={handleInvokeActivateTrip} ><img src={activatetrip_icon} className='activate_icon_width' alt="activate_icon" /></Button> */}
            {/* <Button variant='light' onClick={handleInvokeTripActions} ><img src={tripactions_icon} title='Trip Actions' className='tripaction_icon_width' alt="tripactions_icon" /></Button> */}
            {/* <Button variant='light' onClick={handleInvokeDriverActions} ><img src={driveraction_icon} title='Driver Actions' className='driveractions_icon_width' alt="driveractions_icon" /></Button> */}
            {/* <Button variant='light' onClick={handleInvokeVehicleTracking} ><img src={vehicletracking_icon} title='Send Vehicle Tracking Message' className='vehicletrack_icon_width' alt="vehicletracking_icon" /></Button> */}
            {/* <Button variant='light' onClick={handleInvokeUpdateCallback} ><img src={callback_icon} title='Update Customer Callback Counter' className='callback_icon_width' alt="callback_icon" /></Button> */}
            {/* <Button variant='light' onClick={handleInvokeGroupingActions} ><img src={groupingaction_icon} title='Group/UnGroup Actions' className='groupingactions_icon_width' alt="groupingactions_icon" /></Button> */}
            {/* <Button variant='light' onClick={handleInvokeClusteringActions} ><img src={cluster_icon} title='Build Cluster' className='cluster_icon_width' alt="cluster_icon" /></Button> */}
            {/* <Button variant='light' onClick={handleInvokeTripHistoryActions} ><img src={history_icon} title='Trip History' className='historyactions_icon_width' alt="historyactions_icon" /></Button> */}
            <p className='m-0 mx-1 mt-1 user-select-none d-none'>R:{props.TimeTakenByLastGridCall}&nbsp;</p>
            <p className='m-0 mt-1 user-select-none d-none'>N:{props.NetworkTimeTakenByLastGridCall}</p>
            {(props.options.groupByColumns && props.options.groupByColumns.length > 0) ? <select onChange={handleSetGroupingHeader} title={"Group Table Rows By Column Name"} className='rounded border text-center py-2'>
              {props.options.groupByColumns.map((item, index) => (
                <option key={index} value={item}>{item}</option>
              ))}
            </select> : ""}
          </InputGroup>
        </Form>

      
      {menuSideBarToggle ? 
      "" 
      : 
        <Button type='button' variant='light' style={{ right: '0.3%', top: actionBtnTopPos }} className='border-0 rounded mx-2 px-1 position-absolute' 
          onClick={handleInvokeSidebarToggle} title="Actions Menu Sidebar">
          <Icon icon="bx:menu" className='w-100' style={{ color: "gray", height: "30px", cursor: "pointer", display: "block", zIndex: "999" }} />
        </Button>
      }
      {menuSideBarToggle ? <MenuSideBar SetSidebarStatus={props.setSideBarStatus} options={props.options} navbarTracker={navBarRef.current} btnFuncs={selectedBtns.map(key => buttonConfigsRef.current[key])}
        setMenuSidebarToggle={setMenuSidebar} />
        : ""}

      </Navbar>


      {/* {menuSideBarToggle ? 
      "" 
      : 
      <Button type='button' variant='light' style={{ right: '0.3%', top: actionBtnTopPos }} className='border-0 rounded mx-2 px-1 position-absolute' 
        onClick={handleInvokeSidebarToggle} title="Actions Menu Sidebar"
      >
        <Icon icon="bx:menu" className='w-100' style={{ color: "gray", height: "30px", cursor: "pointer", display: "block", zIndex: "999" }} />
      </Button>}
      {menuSideBarToggle ? <MenuSideBar SetSidebarStatus={props.setSideBarStatus} options={props.options} navbarTracker={navBarRef.current} btnFuncs={selectedBtns.map(key => buttonConfigsRef.current[key])}
        setMenuSidebarToggle={setMenuSidebar} />
        : ""} */}
      {/* {btnName: "Trip Edit", btnFunc: handleInvokeEditTripCallAgent, icon:"edit", title: "Edit a trip"}, */}
      {invokeEditRouteSettings ? <EditRouteSettings affiliate={affiliateRef.current} data={editRouteSetDataRef.current} invokeEditSetting={invokeEditRouteSettings} setInvokeEditRouteSettings={setInvokeEditRouteSettings} SelectedDate={newDateOnEditRoute} /> : ""}
      {showDynamicModal ?
        <Modal centered backdrop="static" keyboard={true} size={(givenDynamicModalSize ? givenDynamicModalSize : 'md')} onHide={() => setShowDynamicModal(false)} show={showDynamicModal} animation={true}>
          <Modal.Header className='text-white activate_dialog_header_bgcolor user-select-none p-0 py-1 px-2' closeButton>
            <Modal.Title style={{ fontSize: "20px" }}>{modalHeaderText}</Modal.Title>
          </Modal.Header>
          <Modal.Body className='fw-normal user-select-none'>{modalBodyHTML}</Modal.Body>
          <Modal.Footer className='p-0 px-2 py-1'>
            {modalFooterHTML}
          </Modal.Footer>
        </Modal>
      : ""}

      {sendEmailDict.showCustomerEmailRequest ? 
        <Modal centered backdrop="static" keyboard={true} onHide={()=>{setSendEmailDict({showCustomerEmailRequest:false, customerTripData:{}});}} show={sendEmailDict.showCustomerEmailRequest} animation={true}>
            <Modal.Header className='activate_dialog_header_bgcolor' closeButton>
                <Modal.Title className='text-white'>{"Email Receipt"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <>
                    <p className='m-0 user-select-none fw-normal'>{"Confirmation No. "}<b>{sendEmailDict.customerTripData["Confirmation #"]}</b></p>
                    <span className='d-flex'>
                        <p className='m-0 user-select-none fw-normal'>{"Customer Email "}</p>
                        <input type="text" className='ms-2 callAgentInputStyle border-0 text-dark' 
                          autoComplete='new_pass' value={customerEmail} onChange={(e)=>{setShowEmailAlert(""); setCustomerEmail(e.target.value);}}
                        />
                    </span>
                    { emailAlert !== "" ? 
                      <p className='m-0 user-select-none fw-normal small text-danger'>{"Please enter the full email address before sending the email."}</p>
                    : ""}
                </> 
            </Modal.Body>
            <Modal.Footer>
                <>
                    <Button variant="dark" className="mx-1 border-0" onClick={()=>{
                        if(customerEmail !== "" && customerEmail.length > 5 && customerEmail.includes("@"))
                        {
                          setSendEmailDict({showCustomerEmailRequest:false, customerTripData:{}}); 
                          SendEmailToCustomer(sendEmailDict.customerTripData);
                        }
                        else
                        {
                          setShowEmailAlert("No Email!");
                        }
                      
                      }}
                    >
                      {"Send"}
                    </Button>
                    <Button variant="secondary" className="mx-1 border-0" onClick={()=>{setShowEmailAlert(""); setSendEmailDict({showCustomerEmailRequest:false, customerTripData:{}}); setCustomerEmail("");}}>
                      {"Cancel"}
                    </Button>
                </>
            </Modal.Footer>
        </Modal>
      : ""}
    </>
  );

};

export default DispatchMainToolbar;
